import MainCard from '@/components/MainCard';
import React, { useEffect, useState } from 'react';
import Base64Viewer from '@/components/Base64Viewer';
import CountDashboard from '@/components/CountDashbord';
import InfoComponent from '@/components/Info';
import {
  Tabs,
  Table,
  Modal,
  Input,
  Timeline,
  Form,
  Drawer,
  Pagination,
  Tag,
  Popover,
  Collapse,
  Descriptions,
  Divider,
  Radio,
  Popconfirm,
  Select as AntSelect,
  Row,
  Col,
  InputNumber,
  Button,
  Card,
  Tooltip,
  Typography as AntTypography,
  Checkbox as AntCheckbox,
  QRCode as AntQRCode,
} from 'antd';
// Material-UI components removed - now using Ant Design
import {
  CloseOutlined,
  EyeOutlined,
  FileSearchOutlined,
  PlusOutlined,
  RetweetOutlined,
  SendOutlined,
  FilterOutlined,
  ArrowLeftOutlined,
  CheckCircleOutlined,
  EditOutlined,
  CloseCircleOutlined,
  SafetyCertificateOutlined,
  ClockCircleFilled,
  FileTextOutlined,
  UserAddOutlined,
  UsergroupAddOutlined,
  MinusSquareOutlined,
  CheckSquareOutlined,
  StopOutlined,
  CommentOutlined,
  ApartmentOutlined,
  HourglassOutlined,
  FileAddOutlined,
  ClockCircleOutlined,
  SearchOutlined,
  PrinterOutlined,
  ReloadOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import Scheduling from './Scheduling';
import { accessControlUtils } from '@/components/AccessControlUtils';
import BmrCheck from '../Configurations/BmrCheck';
import {
  bp_get_batch_report_view,
  get_batch_details_by_process_id,
  get_schedule_batch_details,
  get_running_batch_details,
  get_parent_lot_batch_details,
  get_parent_batch_details,
  get_completed_batch_details,
  get_employee,
  update_schedule_time,
  bp_get_batch_process_by_schedule,
  get_bill_of_materials,
  bp_update_starttime_for_batch_number,
  get_batch_copy_details,
  get_batch_changes_details,
  bp_update_employee_for_batch_number,
  post_api_function,
  delete_batch_details,
  get_api_function,
  get_schedule_recipe_list,
  get_summary_dashboard,
  terminate_batch_details,
  process_scheduling_config,
  release_approval,
  dispensing_scheduling_config,
  batch_configuration_combine,
  get_release_approval_details,
  get_material_lots,
  get_seperate_qr_details,
  reprint_seperate_qr,
} from '@/utils/api';

import { toast } from 'react-toastify';
import useTableConfig from '@/hooks/useTableConfig';
import TableColumnConfig from '@/components/TableColumnConfig';
import OperationsSkeleton from '../RecipeOperationsDetails';
import DAGFlow from '@/pages/dashboard/DAGFlow';
import DAGFlowCopy from '@/pages/dashboard/ArchiMateFlow';
import { DatePicker } from 'antd';
import TableInModal from '@/components/TableInModal';
import CompletedKitting from './CompletedKitting';
import Graph from '../Configurations/Graph';
import { useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { defaultColors } from '@/themes/antd-theme';
import { useTheme } from '@/App';
import { Formik } from 'formik';
import * as Yup from 'yup';
import Icons from '@/components/third-party/Icons';
import DualESignatureAuth from '@/components/DualESignatureAuth';
import ReusableSearchInput from '@/components/ReusableSearch';
import MBMRDetailsModal from '@/components/MBMRDetailsModal';
import { useTranslation } from 'react-i18next';
// Icon component aliases for compatibility with existing code
const LibraryAddIcon = FileAddOutlined;
const AccessTimeIcon = ClockCircleOutlined;
const FilterAltIcon = FilterOutlined;
const ArrowBackIcon = ArrowLeftOutlined;
const CheckCircleIcon = CheckCircleOutlined;
const BorderColorRoundedIcon = EditOutlined;
const CancelIcon = CloseCircleOutlined;
const VerifiedIcon = SafetyCertificateOutlined;
const AccessTimeFilledIcon = ClockCircleFilled;
const WysiwygIcon = FileTextOutlined;
const HowToRegIcon = UserAddOutlined;
const GroupAddIcon = UsergroupAddOutlined;
const CheckBoxIcon = CheckSquareOutlined;
const DisabledByDefaultIcon = StopOutlined;
const CommentIcon = CommentOutlined;
const project_type = 'pharma';
const { Text, Title } = AntTypography;
const { Option } = AntSelect;

// Component aliases for MUI compatibility
const IconButton = Button;
const Typography = AntTypography;
const Grid = Row;
const OutlinedInput = Input;
const Select = AntSelect;
const MenuItem = Option;
const Chip = Tag;
const Box = ({ children, style, ...props }) => (
  <div style={style} {...props}>
    {children}
  </div>
);
// Checkbox alias with MUI-like props support
const Checkbox = ({ checked, icon, checkedIcon, size, ...props }) => (
  <AntCheckbox checked={checked} {...props}>
    {checked ? checkedIcon : icon}
  </AntCheckbox>
);
// FormControlLabel alias for MUI compatibility
const FormControlLabel = ({ control, label, ...props }) => (
  <span style={{ display: 'inline-flex', alignItems: 'center', cursor: 'pointer' }} {...props}>
    {control}
    {label && <span style={{ marginLeft: 4 }}>{label}</span>}
  </span>
);
// ButtonGroup alias for MUI compatibility
const ButtonGroup = Button.Group;

function ScheduledBatches() {
  const { isDark } = useTheme();
  const { t } = useTranslation();
  // Dark mode colors
  const cardBgColor = isDark ? defaultColors.palette.gray[800] : '#ffffff';
  const textColor = isDark ? '#ffffff' : '#1f2937';
  const secondaryTextColor = isDark ? defaultColors.palette.gray[400] : '#6b7280';
  const borderColor = isDark ? defaultColors.palette.gray[600] : '#e5e7eb';
  const tabBgColor = isDark ? defaultColors.palette.gray[700] : '#f9f9f9';
  const sectionBgColor = isDark ? defaultColors.palette.gray[800] : '#ffffff';

  const [user_access_data, set_user_access_data] = useState([]);
  const location = useLocation();
  const [selectedIndustry, set_selectedIndustry] = useState('Pharma');
  const [selectedEmp, setSelectedEmp] = useState([]);
  const appSetting = JSON.parse(localStorage?.getItem('app_setting'));
  const [employeeList, setEmployeeList] = useState([]);
  const [minMaxBatchSize, setMinMaxBatchSize] = useState();
  const [employee, set_employee] = useState([]);
  const [selectedRecipe, setSelectedRecipe] = useState('');
  const [recipe_data, set_recipe_data] = useState([]);
  const [show_add_schedule, set_show_add_schedule] = useState(false);
  const [batch_data, set_batch_data] = useState([]);
  const [approval_data, set_approval_data] = useState([]);
  const [mbmrModal, setMbmrModal] = useState({ open: false, recipeId: null, title: '' });
  const [batchSize, setBatchSize] = useState('');
  const [batch_numberNew, set_batch_numberNew] = useState('');
  const [machine_idNew, set_machine_idNew] = useState('');
  const [searchvalue, setSearchvalue] = useState('');
  const [refresh, set_refresh] = useState(false);
  const [kittingColumnMenu, setKittingColumnMenu] = useState(null);
  const [showGraph, setShowGraph] = useState(false);
  const [is_schedule_lot, set_is_schedule_lot] = useState(false);
  const [selectedBatchNumber, set_selectedBatchNumber] = useState('');
  const [selectedBatchForGraph, setSelectedBatchForGraph] = useState(null);
  const { Panel } = Collapse;
  const navigate = useNavigate();
  const [reportData, setReportData] = useState([]);
  const [processOperations, set_processOperations] = useState([]);
  const [tab_value, set_tab_value] = useState('1');
  const [showSummary, set_showSummary] = useState(false);
  const [showSummaryIndex, set_showSummaryIndex] = useState();
  const [assignStatus, setAssignStatus] = useState(false);
  const [selected_recipe, set_selected_recipe] = useState('');
  const [reportView, setReportView] = useState(false);
  const [workflowReportView, setworkflowReportView] = useState(false);
  const [selectedProcessId, set_selectedProcessId] = useState('');
  const [selectedProcessName, set_selectedProcessName] = useState('');
  const selectedButton = useSelector((state) => state.testProdView);
  const [modifiedData, setModifiedData] = useState([]);
  const [loading, set_loading] = useState(false);
  const [bomList, set_bomList] = useState([]);
  const [bomLoading, setBomLoading] = useState(false);
  const [view_bom_data, set_view_bom_data] = useState(null);
  // Lot picker state for BOM material lot allocation
  const [lotPicker, setLotPicker] = useState({ open: false, material: null, required: 0 });
  const [availableLots, setAvailableLots] = useState([]);
  // Map: material_id -> [{ lot_id, batch_number, lot_number, consumed_qty, available_qty, expiry_date }]
  const [selectedLots, setSelectedLots] = useState({});
  // Per-row in-modal selection state
  const [pickerSelection, setPickerSelection] = useState({});
  const [row_expand, set_row_expand] = useState([]);
  const [batchId, set_selectedBatchId] = useState('');
  const [summaryData, setSummaryData] = useState();
  const [isBmrVisible, setIsBmrVisible] = useState(false);
  //Pagination
  const [total, setTotal] = useState('');
  const [page_number, set_page_number] = useState(1);
  const [isVisible, set_isVisible] = useState(false);
  const [range_value, set_range_value] = useState([]);
  const [modified_details, set_modified_details] = useState([]);
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const { RangePicker } = DatePicker;
  const schedulingAccess = accessControlUtils('Released BMR');
  const isESign = accessControlUtils('ESign')?.create_access || false;
  const [isReject, setisReject] = useState(false);
  const selectedModule = useSelector((state) => state.moduleView);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isBomVisible, setIsBomVisible] = useState(false);
  const [comment, setComment] = useState('');
  const [batch_type, set_batch_type] = useState('master');
  const [master_batch, set_master_batch_number] = useState('master'); // for auto select master batch drop down in release lot page
  const [terminateRecord, setTerminateRecord] = useState();
  const [dag_batch, set_dag_batch] = useState();
  const [productName, setProductName] = useState('');
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [datashow_lot_number, set_datashow_lot_number] = useState('');
  const [rowRecord, setRowRecord] = useState({});
  const [selectedColumnList, set_selectedColumnList] = useState({
    columns: [{ title: 'Placeholder', dataIndex: 'placeholder', key: 'placeholder' }],
    data: [],
  });
  const [showESignatureModal, setShowESignatureModal] = useState(false);
  const [pendingApprovalBatch, setPendingApprovalBatch] = useState(null);
  const [separateQrData, setSeparateQrData] = useState([]);
  const [separateQrTotal, setSeparateQrTotal] = useState(0);
  const [separateQrMaxPage, setSeparateQrMaxPage] = useState(1);
  const [separateQrPage, setSeparateQrPage] = useState(1);
  const [separateQrSearch, setSeparateQrSearch] = useState('');
  const [separateQrLoading, setSeparateQrLoading] = useState(false);
  const [reprintLoading, setReprintLoading] = useState(null);
  const [previewRecord, setPreviewRecord] = useState(null);
  const [previewModalVisible, setPreviewModalVisible] = useState(false);

  const reset_flow = () => {
    set_dag_batch(null);
    setSelectedRowKeys([]);
  };

  // Use table config with safe defaults
  const { visibleColumns, columnConfigMenu, filteredData } = useTableConfig({
    tableKey: 'prodRecipeApprovalTable',
    columns:
      selectedColumnList?.columns?.length > 0
        ? selectedColumnList.columns
        : [{ title: 'Placeholder', dataIndex: 'placeholder', key: 'placeholder' }],
    data: selectedColumnList?.data || [],
    searchValue: searchvalue,
  });
  const ingredientStringConcat = (data, header) => {
    return data?.map((ingredient, index) => {
      let ingredientString = `${ingredient?.material_name?.split('(')[0]} `;
      if (header === 'operation') {
        // Conditionally include the parameter with its min and max values if they exist
        ingredientString += '';
        // ingredient.parameter_name && `(${ingredient.parameter_name}), `;"
      } else {
        ingredientString += `: ${ingredient.quantity}(${ingredient?.material_unit})`;
        if (ingredient.parameter_name !== '') {
          ingredientString += `${ingredient.parameter_name}`;
        } else {
          ingredientString += `-`;
        }
      }
      ingredientString += index === data?.length - 1 ? '' : ',';
      return ingredientString;
    });
  };

  const start_batch = (batch_id, bmrBatch) => {
    bp_update_starttime_for_batch_number(
      {
        batch_id: batch_id,
        bmr_batch: bmrBatch,
      },
      (res) => {
        if (res.status === 'failed') {
          toast.warning(res.message);
        } else {
          toast.success(res.message);
          set_current_expand('');
          get_all_batchDetails();
        }
      }
    );
  };

  const evaluateFormula = (formula, standard, actual, batchSize) => {
    const context = {
      value1: standard,
      value2: actual,
      value3: batchSize,
    };
    try {
      // Create a safe function to evaluate the formula
      const formulaFunction = new Function(...Object.keys(context), `return ${formula};`);

      // Execute the function with dynamic values
      const evaluatedResult = formulaFunction(...Object.values(context));

      return evaluatedResult;
    } catch (error) {
      console.error('Error evaluating formula:', error);
      return 'Error in formula evaluation';
    }
  };

  const buttonStyles = (isSelected) => ({
    width: '100px',
    backgroundColor: isSelected ? '#1976d2' : 'inherit', // Use primary.main color or change it to match your theme
    color: isSelected ? '#ffffff' : 'inherit', // Use primary.contrastText color or change it to match your theme
    border: '1px solid #1976d2', // Optional: to have a consistent border color
    '&:hover': {
      backgroundColor: isSelected ? '#115293' : 'inherit', // Use primary.dark color or change it to match your theme
    },
  });

  const get_batch_details_by_process = async (process_id, batch_number) => {
    try {
      await get_batch_details_by_process_id(res_get_details, {
        process_id: process_id,
        batch_number: batch_number,
      });
    } catch (error) {
      console.log(error);
    }
  };

  const get_summary_dashboard_data = async () => {
    try {
      get_summary_dashboard(
        selectedButton !== 'test'
          ? { recipe_type: 'Production', module_type: selectedModule }
          : { module_type: selectedModule },
        success_all_summaryDetails
      );
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const success_all_summaryDetails = async (res) => {
    if (res?.data?.status === 'success') {
      setSummaryData(res?.data?.data);
    } else {
      setSummaryData();
    }
  };

  const get_recipe = async () => {
    try {
      get_schedule_recipe_list(
        success_bp_get_recipe_meta_data,
        selectedButton !== 'test' ? { recipe_type: 'Production' } : {}
      );
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const success_bp_get_recipe_meta_data = (res) => {
    set_recipe_data(res?.data?.data);
  };

  const get_all_bom_data = async (bom_data) => {
    // Clear the previous recipe's rows immediately so the modal shows a loading
    // state instead of briefly flashing stale data from the last BOM viewed.
    set_bomList([]);
    setBomLoading(true);
    try {
      await get_bill_of_materials(
        { recipe_id: bom_data?.recipe_id, batch_size: bom_data?.batch_size },
        sucess_bom_get
      );
    } catch (error) {
      console.error('Error fetching data:', error);
      setBomLoading(false);
    }
  };

  const sucess_bom_get = (res) => {
    if (res?.data?.data && res?.data?.data?.length > 0) {
      set_bomList(res?.data?.data);
    } else {
      set_bomList([]);
    }
    setBomLoading(false);
  };

  // ===== BOM Lot Picker helpers =====
  const computeRequiredQty = (record) => Number(parseFloat(record?.quantity || 0).toFixed(3));

  const openLotPicker = (record) => {
    const required = computeRequiredQty(record);
    setLotPicker({ open: true, material: record, required });
    // Initialize picker selection from any existing selection for this material
    const existing = selectedLots[record.material_id] || [];
    const sel = {};
    existing.forEach((l) => {
      sel[l.lot_id] = l.consumed_qty;
    });
    setPickerSelection(sel);
    // Fetch available lots for this material
    get_material_lots({ material_id: record.material_id, module_type: selectedModule }, (res) => {
      const lots = res?.data?.data || [];
      // Sort FEFO (earliest expiry first); skip expired/zero
      const today = new Date();
      const usable = lots
        .filter((l) => (l.quantity_available || 0) > 0)
        .filter((l) => !l.expiry_date || new Date(l.expiry_date) >= today)
        .sort(
          (a, b) =>
            new Date(a.expiry_date || '9999-12-31') - new Date(b.expiry_date || '9999-12-31')
        );
      setAvailableLots(usable);
    });
  };

  const closeLotPicker = () => {
    setLotPicker({ open: false, material: null, required: 0 });
    setAvailableLots([]);
    setPickerSelection({});
  };

  const togglePickerLot = (lot, checked) => {
    setPickerSelection((prev) => {
      const next = { ...prev };
      if (checked) {
        next[lot.lot_id] = lot.quantity_available;
      } else {
        delete next[lot.lot_id];
      }
      return next;
    });
  };

  const updatePickerLotQty = (lot_id, qty) => {
    setPickerSelection((prev) => ({ ...prev, [lot_id]: qty }));
  };

  const pickerTotal = Object.values(pickerSelection).reduce((sum, q) => sum + (Number(q) || 0), 0);

  const confirmLotPicker = () => {
    const mat = lotPicker.material;
    if (!mat) return;
    const chosen = availableLots
      .filter((l) => pickerSelection[l.lot_id] !== undefined)
      .map((l) => ({
        lot_id: l.lot_id,
        batch_number: l.batch_number,
        lot_number: l.lot_number,
        consumed_qty: Number(pickerSelection[l.lot_id]) || 0,
        available_qty: l.quantity_available,
        expiry_date: l.expiry_date,
        // Parameter values come directly from the lot's API response — read-only.
        parameter_values: Array.isArray(l.quality_parameters)
          ? l.quality_parameters.map((p) => ({
              parameter_id: p.parameter_id,
              name: p.name,
              unit: p.unit,
              data_type: p.data_type,
              value: p.value ?? null,
            }))
          : [],
      }));
    setSelectedLots((prev) => ({ ...prev, [mat.material_id]: chosen }));
    closeLotPicker();
  };
  // to check all operations are scheduled or not

  const handleTerminate = (record) => {
    setTerminateRecord(record);
    setIsModalVisible(true);
  };

  const onTerminate = () => {
    const req = {
      batch_number: terminateRecord?.batch_number,
      comment: comment,
    };
    terminate_batch(req);
  };

  const handleCommentCancel = () => {
    setComment('');
    setIsModalVisible(false);
  };

  const res_get_details = (res) => {
    if (res?.data?.status === 'success') {
      if (res?.data?.data && res?.data?.data?.length > 0) {
        set_processOperations(res?.data?.data[0]?.operations);
        const reqList = res?.data?.data[0]?.operations?.map((item, index) => {
          return {
            status: false,
            value: '',
            emp_status: '', // Update the key to the index converted to a string
          };
        });
        setScheduleTimeStatus(reqList);
      } else {
        setScheduleTimeStatus([]);
      }
    }
  };

  const formatDate = (date) => {
    const dateObject = new Date(date);
    const formattedDateTime = `${dateObject.getFullYear()}-${(dateObject.getMonth() + 1)
      .toString()
      .padStart(2, '0')}-${dateObject.getDate().toString().padStart(2, '0')} ${dateObject
      .getHours()
      .toString()
      .padStart(2, '0')}:${dateObject.getMinutes().toString().padStart(2, '0')}:${dateObject
      .getSeconds()
      .toString()
      .padStart(2, '0')}`;
    return formattedDateTime;
  };

  const ingredientStrings = (data, header) => {
    return data?.map((ingredient) => {
      let ingredientString = `${ingredient.ingredient_name} `;
      if (header === 'operation') {
        // Conditionally include the parameter with its min and max values if they exist
        ingredientString = `${ingredientString},`;
      } else {
        ingredientString += `${ingredient.ingredient_qty + ' '} ${ingredient.conditinal_para}, `;
        if (
          ingredient.parameter_name !== '' &&
          ingredient.min_value >= 0 &&
          ingredient.max_value > 0
        ) {
          ingredientString += ` (${ingredient.parameter_name} with min ${ingredient.min_value}${ingredient.parameter_name_unit} and max ${ingredient.max_value}${ingredient.parameter_name_unit})`;
        }
      }
      return ingredientString;
    });
  };

  //For collapse open at a time only one row
  const addKeysInFilterDataForCollapse = (filterData) => {
    const updatedFilterList = filterData?.map((item, index) => {
      return {
        ...item,
        key: index.toString(), // Update the key to the index converted to a string
      };
    });
    return updatedFilterList;
  };

  const [current_batch, set_current_batch] = useState('');
  const [current_expand, set_current_expand] = useState('');
  const [current_row_expand, set_current_row_expand] = useState([]);
  const [scheduleTimeStatus, setScheduleTimeStatus] = useState([]);
  const [scheduleTimeEdit, setScheduleTimeEdit] = useState([]);
  const [currentExpandedbatchId, setCurrentExpandedbatchId] = useState();
  const [bulk_assign_list, set_bulk_assign_list] = useState([]);

  const handleExpand = (expanded, record) => {
    if (expanded) {
      get_batch_process_by_schedule(record.batch_number, record.batch_id);
      setCurrentExpandedbatchId(record.batch_id); // set the expanded row batch id
      set_current_batch(record.batch_number);
      set_current_expand(record?.key);
      get_api_function(`/get_employees_for_batch?batch_number=${record.batch_number}`, (res) => {
        if (res.data.status === 'success') {
          set_bulk_assign_list(res.data.data);
        }
      });
    } else {
      set_current_expand('');
    }
  };

  const handleExpandRow = (expanded, record) => {
    if (expanded) {
      set_row_expand(record?.key);
    } else {
      set_row_expand('');
    }
  };

  const handleOperationExpand = (expanded, record) => {
    if (expanded) {
      set_current_row_expand([record?.key]);
      const reqList = record?.operations?.map((item, index) => {
        return {
          status: false,
          value: '',
          emp_status: '', // Update the key to the index converted to a string
        };
      });
      setScheduleTimeStatus(reqList);
    } else {
      set_current_row_expand([]);
      setScheduleTimeStatus([]);
    }
  };

  const [dag_nodes, set_dag_nodes] = useState([]);
  const handleCancel = () => {
    set_isVisible(false);
    setIsBomVisible(false);
  };
  const processColumns = [
    {
      title: 'Process Name',
      dataIndex: 'process_name',
      key: 'Operation',
      align: 'center',
      sorter: (a, b) => a?.process_name?.localeCompare(b?.process_name), // ✅ sorting
    },
    {
      title: 'Process Type',
      dataIndex: 'is_dispensing_process',
      render: (dis) => <Tag color="blue">{dis ? 'Dispensing' : 'Production'}</Tag>,
    },
    {
      title: 'Area',
      dataIndex: 'area_section',
      render: (area) => (
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            maxHeight: '80px', // limit height
            overflowY: 'auto', // scroll when too many lines
            gap: '8px',
          }}
        >
          {area &&
            Array.isArray(area) &&
            area?.length > 0 &&
            area?.map((area, index) => (
              <Tag key={index} color="green">
                {area}
              </Tag>
            ))}
        </div>
      ),
    },
    {
      title: 'Assigned Roles ',
      dataIndex: 'emp_roles',
      render: (roles) => (
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            maxHeight: '80px', // limit height
            overflowY: 'auto', // scroll when too many lines
            gap: '8px',
          }}
        >
          {roles &&
            Array.isArray(roles) &&
            roles?.length > 0 &&
            roles?.map((roles, index) => (
              <Tag key={index} color="green">
                {roles}
              </Tag>
            ))}
        </div>
      ),
    },
  ];
  const expandedRowRenderCols = (record) => {
    const updateData = record?.operations?.map((item, index) => {
      return {
        ...item,
        key: index.toString(), // Update the key to the index converted to a string
      };
    });

    const modiedDataColums = [
      {
        title: 'Operation Number',
        dataIndex: 'operation_number',
        key: 'Operation',
        align: 'center',
      },
      {
        title: 'Operation',
        dataIndex: 'operation_type',
        key: 'operation_type',
        align: 'center',
        render: (data, record, index) => {
          const ingred = ingredientStringConcat(record.ingredients, 'operation');

          return (
            <div style={{ textAlign: 'left' }}>
              <p>
                <strong> Operation Type: </strong>
                {`${data}, `} <br />
                {record?.operation_name && (
                  <>
                    <strong> Operation : </strong>
                    <span>{`${record?.operation_name}, `}</span> <br />
                  </>
                )}
                {record?.instruction?.length > 0 && (
                  <>
                    <strong>Instructions:</strong>
                    <Tooltip title="View Instructions">
                      <IconButton
                        onClick={() => {
                          Modal.info({
                            title: 'Instructions',
                            content: (
                              <ul>
                                {record?.instruction?.map((instruction, index) => (
                                  <li key={index}>{instruction}</li>
                                ))}
                              </ul>
                            ),
                          });
                        }}
                        disabled={record?.instruction?.length === 0}
                      >
                        <EyeOutlined color="info" style={{ fontSize: '21px' }} />
                      </IconButton>
                    </Tooltip>
                    <br />
                  </>
                )}
                {record?.dependencie && (
                  <>
                    <strong> Depending on Operations: </strong>
                    <span>{`${record?.dependencie}`}</span>
                    <br />
                  </>
                )}
                {ingred && ingred?.length > 0 && (
                  <>
                    <strong> Ingredients: </strong>
                    {ingred.join('\n')}
                  </>
                )}
              </p>
            </div>
          );
        },
      },
      {
        title: 'Equipment',
        dataIndex: 'machine_name',
        align: 'center',
        key: 'machine_name',
      },
      {
        title: 'Duration',
        dataIndex: 'max_duration',
        key: 'max_duration',
        align: 'center',
      },
      {
        title: 'Details / Remarks',
        dataIndex: 'products',
        key: 'process_products',
        width: '25%',
        align: 'center',
        render: (data, record, index) => {
          const ingred = ingredientStringConcat(record?.ingredients, '');
          let mul = 'X Batch Size';
          let perc = '% of Batch Size';
          return (
            <div style={{ textAlign: 'left' }}>
              {ingred?.length > 0 && (
                <>
                  <strong> Ingredients: </strong>
                  {/* {ingred?.map((data, index) => (
                        <div key={index}>{data}</div>
                      ))} */}
                  <div className="mb-4">
                    {ingred?.map((data, index) => {
                      return (
                        <>
                          <div key={index}>
                            <strong>{`${index + 1}.  `}</strong>
                            {data?.split('#')?.length > 1
                              ? `${data?.split('#')[0]}-- [${data?.split('#')[1]}] `
                              : data?.replace('-', '')}
                            {/* {record?.ingredients[index]?.is_percentage
                              ? "" + perc
                              : record?.ingredients[index]?.unit + mul} */}
                          </div>
                        </>
                      );
                    })}
                  </div>
                </>
              )}
            </div>
          );
        },
      },
    ];
    return (
      <Table
        dataSource={updateData}
        columns={modiedDataColums}
        pagination={false}
        showHeader={true}
        expandable={{
          expandedRowRender: expandedRowRenderData,
          onExpand: handleExpandRow,
          // onExpandedRowsChange: (expanded) => set_row_expand(expanded),
          expandedRowKeys: [row_expand],
          // expandedRowClassName: () => "col2",
        }}
      />
    );
  };

  const expandedRowRenderData = (record) => {
    return (
      <Collapse accordion>
        {record?.process_products?.length > 0 && (
          <>
            <Panel header="Product" key="1">
              <Table
                size="small"
                pagination={false}
                columns={[
                  {
                    title: 'Product Name',
                    dataIndex: 'product_name',
                    key: 'product_name',
                  },
                  {
                    title: 'Process Thero Quantity',
                    dataIndex: 'process_thero_quantity',
                    key: 'operation_number',
                    render: (data, record, index) => {
                      return <p>{`${data} (${record.product_name_unit})`}</p>;
                    },
                  },
                  {
                    title: 'Expected Min Value',
                    dataIndex: 'process_expec_min_value',
                    key: 'process_expec_min_value',
                    render: (data, record, index) => {
                      return <p>{`${data} (${record.product_name_unit})`}</p>;
                    },
                  },
                  {
                    title: 'Expected Max Value',
                    dataIndex: 'process_expec_max_value',
                    key: 'process_expec_max_value',
                    render: (data, record, index) => {
                      return <p>{`${data} (${record.product_name_unit})`}</p>;
                    },
                  },
                ]}
                dataSource={record?.process_products || []}
                bordered
                style={{ width: '100%' }}
              />
            </Panel>
          </>
        )}

        {record?.process_parameters && record?.process_parameters?.length > 0 && (
          <>
            <Panel header="Process Parameters" key="2">
              <Table
                size="small"
                pagination={false}
                columns={[
                  {
                    title: 'Parameter',
                    dataIndex: 'parameter_name',
                    rowScope: 'row',
                  },
                  {
                    title: 'Readings Per Interval (HH:MM:SS)',
                    dataIndex: 'parameter_max_value',
                    key: 'parameter_max_value',
                    render: (data, record, index) => {
                      return <p>{`${data}`}</p>;
                    },
                  },
                  {
                    title: 'Quantity',
                    dataIndex: 'quantity',
                    key: 'qunatity',
                    align: 'center',
                    render: (data, record) => {
                      return <p>{`${data} (${record?.parameter_name_unit})`}</p>;
                    },
                  },
                  {
                    title: 'Readings',
                    dataIndex: 'reading',
                    key: 'min_value',
                    align: 'center',
                  },
                  {
                    title: 'Min',
                    dataIndex: 'min_value',
                    key: 'min_value',
                    align: 'center',
                    render: (data, record) => {
                      return <p>{data ? `${data} (${record?.parameter_name_unit})` : 'NA'}</p>;
                    },
                  },
                  {
                    title: 'Max',
                    dataIndex: 'max_value',
                    key: 'max_value',
                    align: 'center',
                    render: (data, record) => {
                      return <p>{data ? `${data} (${record?.parameter_name_unit})` : 'NA'}</p>;
                    },
                  },
                ]}
                dataSource={record?.process_parameters || []}
                bordered
                style={{ width: '100%' }}
              />
            </Panel>
          </>
        )}
        {record?.sampling && record?.sampling?.length > 0 && (
          <Panel header="Sampling" key="3">
            <Table
              size="small"
              pagination={false}
              columns={[
                {
                  title: 'Output',
                  align: 'center',
                  dataIndex: 'material_inventory_name',
                  key: 'material_inventory_name',
                },
                {
                  title: 'Quantity',
                  align: 'center',
                  dataIndex: 'quantity',
                  key: 'quantity',
                  render: (data, record, index) => {
                    return <p>{`${data} (${record.material_inventory_unit})`}</p>;
                  },
                },
                {
                  title: 'Testing Type',
                  align: 'center',
                  dataIndex: 'testing_type_name',
                  key: 'testing_type_name',
                },
                {
                  title: 'Parameter',
                  align: 'center',
                  dataIndex: 'parameter_name',
                  key: 'parameter',
                  render: (data, record) => {
                    return data ? data : 'NA';
                  },
                },
                {
                  title: 'Min',
                  align: 'center',
                  dataIndex: 'min_value',
                  key: 'min_value',
                  render: (data) => {
                    return data !== 'NA' ? `${data}(${record?.parameter_name_unit}) ` : 'NA';
                  },
                },
                {
                  title: 'Max',
                  align: 'center',
                  dataIndex: 'max_value',
                  key: 'max_value',
                  render: (data) => {
                    return data !== 'NA' ? `${data}(${record?.parameter_name_unit}) ` : 'NA';
                  },
                },
              ]}
              dataSource={record?.sampling || []}
              bordered
              style={{ width: '100%' }}
            />
          </Panel>
        )}

        {record?.machines && record?.machines?.length > 0 && (
          <Panel header="Machines" key="4">
            <Table
              size="small"
              pagination={false}
              columns={[
                {
                  title: 'Machine Name',
                  dataIndex: 'machine_name',
                  key: 'machine_name',
                },
              ]}
              dataSource={record?.machines || []}
              bordered
              style={{ width: '100%' }}
            />
          </Panel>
        )}
      </Collapse>
    );
  };

  const expandedRowRender = (record) => {
    const updateData = batchProcessBySchedule?.map((item, index) => {
      return {
        ...item,
        key: index.toString(), // Update the key to the index converted to a string
      };
    });
    return (
      <Timeline
        items={updateData?.map((process, index_1) => ({
          color: process?.process_status ? 'green' : '#FAAD14',
          children: (
            <>
              <div
                style={{ display: 'flex', flexDirection: 'row', gap: '8px', alignItems: 'center' }}
              >
                <Typography>
                  <b>{'Process: '}</b>
                  {`${process?.process_number}`}
                </Typography>

                {/* // !process?.operations?.length > 0 ? (
                  //   <Tag color="red">{"Pending"}</Tag>
                  // ) : */}

                <>
                  {process?.process_status ? (
                    <Tooltip title="All Operations Scheduled">
                      <VerifiedIcon
                        color="success"
                        style={{ fontSize: '20px', cursor: 'pointer' }}
                      />
                    </Tooltip>
                  ) : (
                    <Tooltip title="Schedule Pending">
                      <AccessTimeFilledIcon
                        color="warning"
                        style={{ fontSize: '20px', cursor: 'pointer' }}
                      />
                    </Tooltip>
                  )}
                  {showSummaryIndex !== index_1 ? (
                    <Tooltip title="View Operations">
                      <IconButton
                        onClick={() => {
                          set_dag_nodes([`${process?.op_id}`]);
                          view_operation_function(process);
                          set_showSummaryIndex(index_1);
                        }}
                      >
                        <EyeOutlined
                          style={{
                            fontSize: '20px',
                            color:
                              process?.progress === 'Completed'
                                ? 'green'
                                : process?.progress === 'In Process'
                                ? 'orange'
                                : process?.progress === 'Pending' && 'red',
                          }}
                        />
                      </IconButton>
                    </Tooltip>
                  ) : (
                    <Tooltip title="Close">
                      <IconButton
                        onClick={() => {
                          set_showSummary(false);
                        }}
                      >
                        <CloseOutlined color="primary" />
                      </IconButton>
                    </Tooltip>
                  )}
                </>
              </div>
            </>
          ),
        }))}
      />
    );
  };
  // collapse for operations
  const expandedRowRenderForOperations = (record) => {
    const updateData = record?.operations?.map((item, index) => {
      return {
        ...item,
        key: index.toString(), // Update the key to the index converted to a string
      };
    });

    const operationsColumns = [
      {
        title: 'Operation Number',
        dataIndex: 'operation_number',
        key: 'Operation',
        align: 'center',
      },
      {
        title: 'Operation',
        dataIndex: 'operation_type',
        width: '18%',
        key: 'operation_type',
        align: 'center',
        render: (data, record, index) => {
          const ingred = ingredientStrings(record.ingredients, 'operation');

          return (
            <div style={{ textAlign: 'left' }}>
              <p>
                <strong> Operation Type: </strong>
                {`${data}, `} <br />
                {record?.operation_name && (
                  <>
                    <strong> Operation : </strong>
                    <span>{`${record?.operation_name}, `}</span> <br />
                  </>
                )}
                <strong> Instruction: </strong> {`${record.instruction}`}
              </p>
              <p>
                {ingred && ingred.length > 0 && (
                  <>
                    <strong> Ingredients: </strong>
                    {ingred.join('\n')}
                  </>
                )}
              </p>
            </div>
          );
        },
      },
      // {
      //   title: "Batch Id",
      //   dataIndex: "batch_id",
      //   key: "batch_id",
      //   align: "center",
      // },
      {
        title: 'Equipment',
        dataIndex: 'machine_name',
        align: 'center',
        width: '8%',
        key: 'machine_name',
      },
      {
        title: 'Duration',
        dataIndex: 'max_duration',
        key: 'max_duration',
        width: '8%',
        align: 'center',
      },
      {
        title: 'Details / Remarks',
        dataIndex: 'products',
        key: 'process_products',
        width: '25%',
        align: 'center',
        render: (data, record, index) => {
          const columns = [
            {
              title: 'Product Name',
              dataIndex: 'product_name',
              key: 'product_name',
            },
            {
              title: 'Process Thero Quantity',
              dataIndex: 'process_thero_quantity',
              key: 'operation_number',
              render: (data, record, index) => {
                return <p>{`${data} (${record.product_name_unit})`}</p>;
              },
            },
            {
              title: 'Expected Min Value',
              dataIndex: 'process_expec_min_value',
              key: 'process_expec_min_value',
              render: (data, record, index) => {
                return <p>{`${data} (${record.product_name_unit})`}</p>;
              },
            },
            {
              title: 'Expected Max Value',
              dataIndex: 'process_expec_max_value',
              key: 'process_expec_max_value',
              render: (data, record, index) => {
                return <p>{`${data} (${record.product_name_unit})`}</p>;
              },
            },
          ];

          const machineCols = [
            // {
            //   title: "Machine Id",
            //   dataIndex: "machine_id",
            //   key: "machine_name",
            // },
            {
              title: 'Machine Name',
              dataIndex: 'machine_name',
              key: 'machine_name',
            },
          ];

          const pr_columns = [
            {
              title: 'Parameter',
              dataIndex: 'parameter_name',
              rowScope: 'row',
            },
            {
              title: 'Readings Per Interval (HH:MM:SS)',
              dataIndex: 'parameter_max_value',
              key: 'parameter_max_value',
              render: (data, record, index) => {
                return <p>{`${data}`}</p>;
              },
            },
            {
              title: 'Quantity',
              dataIndex: 'qunatity',
              key: 'qunatity',
              align: 'center',
              render: (data, record) => {
                return <p>{`${data} (${record?.parameter_name_unit})`}</p>;
              },
            },
            {
              title: 'Readings',
              dataIndex: 'reading',
              key: 'min_value',
              align: 'center',
            },
            {
              title: 'Min',
              dataIndex: 'min_value',
              key: 'min_value',
              align: 'center',
              render: (data, record) => {
                return <p>{data ? `${data} (${record?.parameter_name_unit})` : 'NA'}</p>;
              },
            },
            {
              title: 'Max',
              dataIndex: 'max_value',
              key: 'max_value',
              align: 'center',
              render: (data, record) => {
                return <p>{data ? `${data} (${record?.parameter_name_unit})` : 'NA'}</p>;
              },
            },
          ];

          const samplingCols = [
            {
              title: 'Output',
              align: 'center',
              dataIndex: 'material_inventory_name',
              key: 'material_inventory_name',
            },
            {
              title: 'Quantity',
              align: 'center',
              dataIndex: 'quantity',
              key: 'quantity',
              render: (data, record, index) => {
                return <p>{`${data} (${record.material_inventory_unit})`}</p>;
              },
            },
          ];

          const ingred = ingredientStrings(record.ingredients, '');
          return (
            <div style={{ textAlign: 'left' }}>
              {ingred?.length > 0 && (
                <>
                  <strong> Ingredients: </strong>
                  <div className="mb-4">{ingred.join('\n')}</div>
                </>
              )}

              {data && data.length > 0 && (
                <>
                  <div className="mb-3">
                    <strong> Product: </strong>
                  </div>
                  <div style={{ margin: 10, marginLeft: -35 }}>
                    <Table
                      size="small"
                      pagination={false}
                      columns={columns}
                      dataSource={data}
                      bordered
                      style={{ width: '100%' }}
                    />
                  </div>
                  <br />
                </>
              )}
              {record.paramaters && record.paramaters?.length > 0 && (
                <>
                  <div className="mb-3">
                    <strong> Process Parameters: </strong>
                  </div>
                  <div style={{ margin: 10, marginLeft: -35 }}>
                    <Table
                      size="small"
                      pagination={false}
                      columns={pr_columns}
                      dataSource={record.paramaters}
                      bordered
                      style={{ width: '100%' }}
                    />
                  </div>
                  <br />
                </>
              )}

              {record.operation_type === 'Sampling' &&
                record.sampling &&
                record.sampling.length > 0 && (
                  <>
                    <div className="mb-3">
                      <strong> Sampling: </strong>
                    </div>
                    <div style={{ margin: 10, marginLeft: -35 }}>
                      <Table
                        size="small"
                        pagination={false}
                        columns={samplingCols}
                        dataSource={record.sampling}
                        bordered
                        style={{ width: '100%' }}
                      />
                    </div>
                  </>
                )}

              {record.operation_number === 1 &&
                record.machine_list &&
                record.machine_list?.length > 0 && (
                  <>
                    <div className="mb-3">
                      <strong> Machines: </strong>
                    </div>
                    <div style={{ margin: 10, marginLeft: -35 }}>
                      <Table
                        size="small"
                        pagination={false}
                        columns={machineCols}
                        dataSource={record.machine_list}
                        bordered
                        style={{ width: '100%' }}
                      />
                    </div>
                  </>
                )}
            </div>
          );
        },
      },
      {
        title: 'Schedule Time',
        dataIndex: 'schedule_date',
        key: 'schedule_time',
        width: '10%',
        align: 'center',
        render: (data, record, index) => {
          if (scheduleTimeStatus[index]?.status) {
            return (
              <>
                <div style={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>
                  <OutlinedInput
                    id="des"
                    type="datetime-local"
                    size="small"
                    name="des"
                    fullWidth
                    inputProps={{
                      min:
                        index === 0
                          ? formatDate(data)
                          : formatDate(updateData[index - 1]?.schedule_date), // for schedule nma efor operation1 should be greater than actual value and 2nd index should be greater than privious
                    }}
                    disabled={!scheduleTimeStatus[index]?.status}
                    //   onClick={() => setIsScheduledDateEdit(true)} // Set isEditing to true on click
                    onChange={(e) => {
                      const updatedScheduleTimeStatus = [...scheduleTimeStatus];
                      updatedScheduleTimeStatus[index].value = e.target.value;
                      setScheduleTimeStatus(updatedScheduleTimeStatus);
                    }}
                  />
                  <Tooltip title="Close">
                    <IconButton
                      onClick={() => {
                        const updatedScheduleTimeStatus = [...scheduleTimeStatus];
                        updatedScheduleTimeStatus[index].status = false;
                        updatedScheduleTimeStatus[index].value = '';
                        setScheduleTimeStatus(updatedScheduleTimeStatus);
                      }}
                    >
                      <CancelIcon color="error" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Save">
                    <IconButton
                      disabled={!scheduleTimeStatus[index].value}
                      onClick={() => {
                        const updatedScheduleTimeStatus = [...scheduleTimeStatus];
                        updatedScheduleTimeStatus[index].status = false;
                        assign_employee({
                          batch_schedule_time: scheduleTimeStatus[index].value,
                          batch_id: record?.batch_id,
                        });
                        setScheduleTimeStatus(updatedScheduleTimeStatus);
                      }}
                    >
                      <CheckCircleIcon color="success" />
                    </IconButton>
                  </Tooltip>
                </div>
              </>
            );
          } else {
            const dateObject = new Date(data);
            const formattedDateTime = `${dateObject.getFullYear()}-${(dateObject.getMonth() + 1)
              .toString()
              .padStart(2, '0')}-${dateObject.getDate().toString().padStart(2, '0')} ${dateObject
              .getHours()
              .toString()
              .padStart(2, '0')}:${dateObject.getMinutes().toString().padStart(2, '0')}:${dateObject
              .getSeconds()
              .toString()
              .padStart(2, '0')}`;
            return (
              <>
                <div style={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>
                  <span>{formattedDateTime}</span>
                  <Tooltip title="Edit">
                    <IconButton
                      onClick={() => {
                        const updatedScheduleTimeStatus = [...scheduleTimeStatus];
                        updatedScheduleTimeStatus[index].status = true;
                        setScheduleTimeStatus(updatedScheduleTimeStatus);
                      }}
                    >
                      <BorderColorRoundedIcon color="primary" />
                    </IconButton>
                  </Tooltip>
                </div>
              </>
            );
          }
        },
      },
      {
        title: 'Assign',
        dataIndex: '',
        key: 'assign',
        width: '18%',
        align: 'center',
        render: (data, record, index) => {
          return record?.select_emp_list?.length <= 0 ||
            (scheduleTimeStatus?.length > 0 && scheduleTimeStatus[index]?.emp_status) ? (
            <div style={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>
              <Select
                multiple
                labelId="demo-select-small-label"
                id="demo-select-small"
                value={selectedEmp[index] || []}
                style={{ width: 150 }}
                required
                onChange={(e) => {
                  let temp = [...selectedEmp];
                  temp[index] = e.target.value;
                  setSelectedEmp(temp);
                }}
              >
                {record?.emp_list?.map((mdata) => (
                  <MenuItem value={mdata.employee_id}>{mdata.employee_name}</MenuItem>
                ))}
              </Select>
              <Tooltip title="Close">
                <IconButton
                  onClick={() => {
                    const updatedScheduleTimeStatus = [...scheduleTimeStatus];
                    updatedScheduleTimeStatus[index].emp_status = false;
                    setScheduleTimeStatus(updatedScheduleTimeStatus);
                  }}
                >
                  <CancelIcon color="error" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Assign">
                <IconButton
                  disabled={!selectedEmp[index] || false}
                  onClick={() => {
                    assign_employee({
                      employee_id: selectedEmp[index],
                      batch_id: record?.batch_id,
                    });
                    const updatedScheduleTimeStatus = [...scheduleTimeStatus];
                    updatedScheduleTimeStatus[index].emp_status = false;
                    setScheduleTimeStatus(updatedScheduleTimeStatus);
                  }}
                >
                  <CheckCircleIcon color="success" />
                </IconButton>
              </Tooltip>
            </div>
          ) : (
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                flexWrap: 'wrap',
                gap: '5px',
              }}
            >
              {record?.select_emp_list?.map((emp) => (
                <Chip
                  style={{
                    margin: 8,
                  }}
                  label={emp}
                />
              ))}
              <Tooltip title="Reassign">
                <IconButton
                  onClick={() => {
                    const updatedScheduleTimeStatus = [...scheduleTimeStatus];
                    updatedScheduleTimeStatus[index].emp_status = true;
                    setScheduleTimeStatus(updatedScheduleTimeStatus);
                  }}
                >
                  <BorderColorRoundedIcon color="primary" />
                </IconButton>
              </Tooltip>
            </div>
          );
        },
      },
    ];
    return (
      <Table columns={operationsColumns} dataSource={updateData} pagination={false} bordered />
    );
  };

  const get_view_function = () => {
    return user_access_data?.find((item) => item.module_name === 'Result')?.read_access
      ? [
          {
            title: 'Summary Result',
            dataIndex: 'summaryDetails',
            key: 'id',
            align: 'center',
            render: (data, record, index) => {
              return (
                <IconButton
                  size="medium"
                  onClick={() => {
                    set_current_batch(record?.batch_number);
                    getBatchReportData(record?.batch_number);
                    set_selected_recipe(record?.recipe_name);
                    setReportView(true);
                  }}
                >
                  <EyeOutlined color="primary" />
                </IconButton>
              );
            },
          },
        ]
      : [];
  };

  const [batchProcessBySchedule, setBatchProcessBySchedule] = useState([]);

  const get_batch_process_by_schedule = async (batchNo, batchId) => {
    try {
      await bp_get_batch_process_by_schedule(
        batchNo.toString(),
        batchId,
        success_get_batch_process_by_schedule
      );
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const success_get_batch_process_by_schedule = (res) => {
    setBatchProcessBySchedule(res?.data?.data);
    // if (curruntExpandedkey !== "") {
    //   set_processOperations(res?.data?.data[curruntExpandedkey]?.operations);
    // }
  };

  const get_employee_list = async () => {
    try {
      await get_employee(successGetEmployee);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const successGetEmployee = (res) => {
    setEmployeeList(res?.data?.data);
  };

  const update_scheduleTime = async (req) => {
    try {
      await update_schedule_time(req, successScheduleTime);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const successScheduleTime = (res) => {
    if (res?.status === 'success') {
      toast?.success(res?.message);
      set_refresh(!refresh);
    } else {
      toast?.warning(res?.message);
    }
  };

  const terminate_batch = async (req) => {
    try {
      await terminate_batch_details(req, success_terminate_batch);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const success_terminate_batch = (res) => {
    if (res?.status === 'success') {
      toast?.success(res?.message);
      set_refresh(!refresh);
      setIsModalVisible(false);
      setComment('');
    } else {
      toast?.warning(res?.message);
    }
  };

  const delete_batchDetails = async (req) => {
    try {
      await delete_batch_details(req, successDeleteBatch);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const successDeleteBatch = (res) => {
    if (res?.status === 'success') {
      toast?.success(res?.message);
      set_refresh(!refresh);
    } else {
      toast?.warning(res?.message);
    }
  };

  const assign_employee = async (assignReq) => {
    try {
      await bp_update_employee_for_batch_number(assignReq, success_assign_employee);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const success_assign_employee = (res) => {
    if (res.status === 'failed') {
      toast.warning(res.message);
    } else {
      toast.success(res.message);
      handleExpand(true, {
        batch_number: current_batch,
        batch_id: currentExpandedbatchId,
        key: current_expand,
      });
      // handleExpand();
    }
  };

  const success_assign_all_employee = (res) => {
    if (res.status === 'failed') {
      toast.warning(res.message);
    } else {
      setAssignStatus(!assignStatus);
      toast.success(res.message);
    }
  };

  const get_view_function1 = () => {
    return user_access_data?.find((item) => item.module_name === 'Result')?.read_access
      ? [
          {
            title: tab_value === '6' ? 'Summary' : 'Summary Result',
            dataIndex: 'summaryDetails',
            key: 'id',
            align: 'center',
            width: 50,
            render: (data, record, index) => {
              return (
                <IconButton
                  size="medium"
                  type="reset"
                  onClick={() => {
                    set_current_batch(record?.batch_number);
                    // handleOperationExpand(true, record);
                    if (record?.lots && record?.lots?.length > 0) {
                      getParentLotBatchDetails(record?.batch_number);
                    } else {
                      getBatchReportData(record?.batch_number);
                    }
                    set_selected_recipe(record?.recipe_name);
                    setReportView(true);
                  }}
                >
                  <EyeOutlined
                    // color={record?.status ? "success" : "error"}
                    color="primary"
                  />
                </IconButton>
              );
              // ) : (
              //   <Tooltip title="Operation Not completed">
              //     <EyeOutlined color="warning" />
              //   </Tooltip>
              // );
            },
          },
        ]
      : [];
  };

  const handleApprove = (record) => {
    if (isESign) {
      setPendingApprovalBatch(record);
      setShowESignatureModal(true);
    } else {
      // Show confirmation modal before approving
      Modal.confirm({
        title: 'Approve Batch',
        content: (
          <div>
            <p>
              Are you sure you want to approve batch <b>{record.batch_number}</b>?
            </p>
          </div>
        ),
        okText: 'Approve',
        cancelText: 'Cancel',
        onOk() {
          handleApproveBatch(record);
        },
      });
    }
  };

  const handleApproveBatch = (record) => {
    const req =
      selectedButton === 'production'
        ? {
            recipe_type: true,
            start_time: fromDate,
            end_time: toDate,
            page_number: page_number,
            module_type: selectedModule,
            ...(searchvalue && { search: searchvalue }),
            ...(selectedRecipe && { recipe_id: selectedRecipe }),
          }
        : fromDate && toDate
        ? {
            start_time: fromDate,
            end_time: toDate,
            page_number: page_number,
            module_type: selectedModule,
            ...(searchvalue && { search: searchvalue }),
            ...(selectedRecipe && { recipe_id: selectedRecipe }),
          }
        : {
            page_number: page_number,
            module_type: selectedModule,
            ...(searchvalue && { search: searchvalue }),
            ...(selectedRecipe && { recipe_id: selectedRecipe }),
          };

    set_loading(true);
    release_approval({ batch_number: record.batch_number, approval: true }, (res) => {
      if (res?.status === 'success') {
        toast.success(res?.message);
        get_release_approval_details(req, (res) => {
          if (res?.data?.status === 'success') {
            const data = res?.data?.data;
            set_approval_data(data);
            setTotal(res?.data?.obj_count);
            set_loading(false);
          }
        });
      } else {
        toast.warning(res?.message);
      }
    });
  };

  const handleReject = (record) => {
    let comment = '';
    Modal.error({
      title: 'Reject Batch',
      okText: 'Reject',
      okButtonProps: { danger: true },
      content: (
        <div>
          <p>
            Please provide a reason for rejecting <b>{record.batch_number}</b>:
          </p>
          <Input.TextArea
            rows={3}
            onChange={(e) => (comment = e.target.value)}
            placeholder="Enter your comments here"
          />
        </div>
      ),
      onOk() {
        const req =
          selectedButton === 'production'
            ? {
                recipe_type: true,
                start_time: fromDate,
                end_time: toDate,
                page_number: page_number,
                module_type: selectedModule,
                ...(searchvalue && { search: searchvalue }),
                ...(selectedRecipe && { recipe_id: selectedRecipe }),
              }
            : fromDate && toDate
            ? {
                start_time: fromDate,
                end_time: toDate,
                page_number: page_number,
                module_type: selectedModule,
                ...(searchvalue && { search: searchvalue }),
                ...(selectedRecipe && { recipe_id: selectedRecipe }),
              }
            : {
                page_number: page_number,
                module_type: selectedModule,
                ...(searchvalue && { search: searchvalue }),
                ...(selectedRecipe && { recipe_id: selectedRecipe }),
              };
        if (!comment.trim()) {
          toast.warning('Comment is required for rejection.');
          return;
        }
        set_loading(true);
        release_approval({ batch_number: record.batch_number, approval: false, comment }, (res) => {
          if (res?.status === 'success') {
            toast.success(res?.message);
            get_release_approval_details(req, (res) => {
              if (res?.data?.status === 'success') {
                const data = res?.data?.data;
                set_approval_data(data);
                setTotal(res?.data?.obj_count);
                set_loading(false);
              }
            });
          } else {
            toast.warning(res?.message);
          }
        });
      },
    });
  };

  const modified_Batch_columns = [
    {
      title: selectedModule === 'prod' ? 'MBMR' : 'MBPR',
      dataIndex: 'recipe_name',
      key: 'recipe_name',
      align: 'center',
      width: 200,
      sorter: (a, b) => a?.recipe_name?.localeCompare(b?.recipe_name), // ✅ sorting
      render: (text) => (
        <Tooltip title={text} placement="top">
          <div className="truncate w-full">{text}</div>
        </Tooltip>
      ),
    },
    {
      title: selectedModule === 'prod' ? 'BMR' : 'BPR' + 'Number',
      dataIndex: 'batch_number',
      key: 'batch_number',
      align: 'center',
      width: 200,
      sorter: (a, b) => a?.batch_number?.localeCompare(b?.batch_number), // ✅ sorting
      render: (text) => (
        <Tooltip title={text} placement="top">
          <div className="truncate w-full">{text}</div>
        </Tooltip>
      ),
    },
    {
      title: 'View Details',
      dataIndex: 'dt',
      key: 'view_details',
      align: 'center',
      width: 150,
      render: (data, record, index) => {
        return (
          <div className="flex justify-center items-center w-full">
            <Tooltip title="View Details">
              <button
                className="flex items-center justify-center p-1 rounded-md bg-blue-500 text-white transition-transform duration-200 hover:bg-blue-600 hover:scale-110"
                onClick={() => {
                  get_batch_changesDetails(record?.recipe_id);
                  set_isVisible(true);
                }}
              >
                <Icons.Eye size={16} />
              </button>
            </Tooltip>
          </div>
        );
      },
    },
  ];

  const completed_Batch_columns = [
    {
      title: selectedModule === 'prod' ? 'MBMR' : 'MBPR',
      dataIndex: 'recipe_name',
      key: 'recipe_name',
      align: 'center',
      width: 150,
      sorter: (a, b) => a?.recipe_name?.localeCompare(b?.recipe_name), // ✅ sorting
      render: (text) => (
        <Tooltip title={text} placement="top">
          <div className="truncate w-full">{text}</div>
        </Tooltip>
      ),
    },
    {
      title: selectedModule === 'prod' ? 'BMR' : 'BPR',
      dataIndex: 'batch_number',
      key: 'batch_number',
      align: 'center',
      width: 150,
      sorter: (a, b) => a?.batch_number?.localeCompare(b?.batch_number),
      render: (text) => (
        <Tooltip title={text} placement="top">
          <div className="truncate w-full">{text}</div>
        </Tooltip>
      ),
    },
    {
      title: selectedModule === 'prod' ? 'BMR Size' : 'BPR Size',
      dataIndex: 'batch_size',
      key: 'batch_size',
      align: 'center',
      width: 120,
      sorter: (a, b) => a?.batch_size - b?.batch_size, // ✅ numeric sort
      render: (text) => (
        <Tooltip title={text} placement="top">
          <div className="truncate w-full">{text}</div>
        </Tooltip>
      ),
    },
    {
      title: 'Machine',
      dataIndex: 'machine',
      key: 'machine',
      align: 'center',
      width: 120,
      sorter: (a, b) => a?.machine?.localeCompare(b?.machine),
      render: (text) => (
        <Tooltip title={text} placement="top">
          <div className="truncate w-full">{text}</div>
        </Tooltip>
      ),
    },
    {
      title: 'Scheduled Time',
      dataIndex: 'batch_schedule_time',
      key: 'batch_schedule_time',
      width: 150,
      align: 'center',
      sorter: (a, b) => new Date(a?.batch_schedule_time) - new Date(b?.batch_schedule_time),
      render: (data) => (
        <Tooltip title={data} placement="top">
          <div className="truncate w-full">{data?.slice(0, 16)}</div>
        </Tooltip>
      ),
    },
    {
      title: 'Start Time',
      dataIndex: 'batch_start_time',
      key: 'batch_start_time',
      width: 150,
      align: 'center',
      sorter: (a, b) => new Date(a.batch_start_time) - new Date(b.batch_start_time),
      render: (batch_start_time) => (
        <Tooltip title={batch_start_time} placement="top">
          <div className="truncate w-full">{batch_start_time?.slice(0, 16)}</div>
        </Tooltip>
      ),
    },
    {
      title: 'Completion Time',
      dataIndex: 'batch_end_time',
      key: 'batch_end_time',
      width: 150,
      align: 'center',
      sorter: (a, b) => new Date(a?.batch_end_time) - new Date(b?.batch_end_time),
      render: (batch_end_time) => (
        <Tooltip title={batch_end_time} placement="top">
          <div className="truncate w-full">{batch_end_time?.slice(0, 16)}</div>
        </Tooltip>
      ),
    },
    {
      title: 'Duration',
      dataIndex: 'duration',
      key: 'duration',
      width: 100,
      align: 'center',
      sorter: (a, b) => (a?.duration || 0) - (b?.duration || 0), // ✅ numeric sort
      render: (text) => (
        <Tooltip title={text} placement="top">
          <div className="truncate w-full">{text}</div>
        </Tooltip>
      ),
    },
    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   key: "status",
    //   align: "center",
    //   render: (data, record, index) => {
    //     return (
    //       <Button
    //         onClick={() => {
    //           setShowGraph(true);
    //           setSelectedBatchForGraph(record.batch_number);
    //         }}
    //       >
    //         <AutoGraphIcon color="primary" />
    //       </Button>
    //     );
    //   },
    // },
    {
      title: 'Approval Status',
      dataIndex: 'role_list',
      key: 'process_roles',
      width: 250,
      align: 'center',
      render: (processRoles) => (
        <div className="w-full">
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div
              style={{ display: 'flex', flexDirection: 'row', gap: '8px' }}
              className="flex-wrap"
            >
              {processRoles &&
                processRoles?.some((role) => role.role_name === 'Production Manager') && (
                  <Tooltip
                    title={
                      processRoles?.find((role) => role.role_name === 'Production Manager')
                        .approval_status === 'approve'
                        ? 'Approved'
                        : 'Approval Pending'
                    }
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          size="small"
                          icon={
                            isReject ? (
                              <DisabledByDefaultIcon color="error" fontSize="small" />
                            ) : undefined
                          }
                          checkedIcon={<CheckBoxIcon fontSize="small" />}
                          checked={
                            processRoles?.find((role) => role.role_name === 'Production Manager')
                              .approval_status === 'approve'
                              ? true
                              : false
                          }
                        />
                      }
                      label={<span className="text-sm">Production</span>}
                    />
                  </Tooltip>
                )}
              {processRoles && processRoles?.some((role) => role.role_name === 'R&D') && (
                <Tooltip
                  title={
                    processRoles?.find((role) => role.role_name === 'R&D').approval_status ===
                    'approve'
                      ? 'Approved'
                      : 'Approval Pending'
                  }
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        size="small"
                        icon={
                          isReject ? (
                            <DisabledByDefaultIcon color="error" fontSize="small" />
                          ) : undefined
                        }
                        checkedIcon={<CheckBoxIcon fontSize="small" />}
                        checked={
                          processRoles?.find((role) => role.role_name === 'R&D').approval_status ===
                          'approve'
                            ? true
                            : false
                        }
                      />
                    }
                    label={<span className="text-sm">R&D</span>}
                  />
                </Tooltip>
              )}
              {processRoles && processRoles?.some((role) => role.role_name === 'QA') && (
                <Tooltip
                  title={
                    processRoles?.find((role) => role.role_name === 'QA').approval_status ===
                    'approve'
                      ? 'Approved'
                      : 'Approval Pending'
                  }
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        size="small"
                        icon={
                          isReject ? (
                            <DisabledByDefaultIcon color="error" fontSize="small" />
                          ) : undefined
                        }
                        checkedIcon={<CheckBoxIcon fontSize="small" />}
                        checked={
                          processRoles?.find((role) => role.role_name === 'QA').approval_status ===
                          'approve'
                            ? true
                            : false
                        }
                      />
                    }
                    label={<span className="text-sm">QA</span>}
                  />
                </Tooltip>
              )}
            </div>
          </div>
        </div>
      ),
    },
    // ...get_view_function(),
    {
      title: 'Action',
      dataIndex: '',
      key: 'material_balance',
      width: 120,
      align: 'center',
      render: (_, record) => {
        return (
          <div className="flex justify-center items-center w-full gap-2">
            {/* View Report */}
            <Tooltip title="View Report">
              <button
                className="flex items-center justify-center p-1 rounded-md bg-blue-500 text-white transition-transform duration-200 hover:bg-blue-600 hover:scale-110"
                onClick={() => {
                  set_current_batch(record?.batch_number);
                  getBatchReportData(record?.batch_number);
                  set_selected_recipe(record?.recipe_name);
                  setReportView(true);
                }}
              >
                <Icons.Eye className="w-5 h-5" />
              </button>
            </Tooltip>

            {/* Material Balance */}
            <Tooltip title="Material Balance">
              <button
                className="flex items-center justify-center p-1 rounded-md bg-green-500 text-white transition-transform duration-200 hover:bg-green-600 hover:scale-110"
                onClick={() =>
                  navigate('/bal-material', {
                    state: { batch_number: record?.batch_number || '' },
                  })
                }
              >
                <Icons.FileText className="w-5 h-5" />
              </button>
            </Tooltip>
          </div>
        );
      },
    },
    ...(isReject
      ? [
          {
            title: 'Rejection Comment',
            dataIndex: '',
            key: 'rejection_comment',
            width: 120,
            align: 'center',
            render: (data, record, index) => {
              return (
                <div className="flex justify-center items-center w-full">
                  <Tooltip title="Rejection Comment">
                    <IconButton
                      size="small"
                      onClick={() => {
                        Modal.info({
                          title: 'Rejection Comment',
                          content: <>{record?.comment || ''}</>,
                        });
                      }}
                    >
                      <CommentIcon color="error" style={{ fontSize: '20px' }} />
                    </IconButton>
                  </Tooltip>
                </div>
              );
            },
          },
        ]
      : []),
  ];

  const recipe_details_columns = [
    selectedModule === 'pack' && {
      title: 'Used BMR',
      dataIndex: 'used_batch',
      key: 'id',
      align: 'center',
      width: 150,
      sorter: (a, b) => a?.used_batch?.localeCompare(b?.used_batch), // ✅ sorting
      render: (text) => (
        <Tooltip title={text} placement="top">
          <div className="truncate w-full">{text}</div>
        </Tooltip>
      ),
    },
    {
      title: selectedModule === 'prod' ? 'MBMR' : 'MBPR',
      dataIndex: 'recipe_name',
      key: 'id',
      align: 'center',
      width: 150,
      sorter: (a, b) => a?.recipe_name?.localeCompare(b?.recipe_name), // ✅ sorting
      render: (text) => (
        <Tooltip title={text} placement="top">
          <div className="truncate w-full">{text}</div>
        </Tooltip>
      ),
    },
    {
      title: selectedModule === 'prod' ? 'BMR' : 'BPR',
      dataIndex: 'batch_number',
      key: 'id',
      align: 'center',
      width: 150,
      sorter: (a, b) => a?.batch_number?.localeCompare(b?.batch_number), // ✅ sorting
      render: (text) => (
        <Tooltip title={text} placement="top">
          <div className="truncate w-full">{text}</div>
        </Tooltip>
      ),
    },
    tab_value === '2' && {
      title: 'Master/Lot',
      dataIndex: 'parent_number',
      key: 'parent_number',
      align: 'center',
      width: 120,
      sorter: (a, b) => a?.parent_number?.localeCompare(b?.parent_number), // ✅ sorting
      render: (text) => (
        <Tooltip title={text} placement="top">
          <div className="truncate w-full">{text}</div>
        </Tooltip>
      ),
    },
    {
      title: 'Scheduled Time',
      dataIndex: 'batch_schedule_time',
      key: 'batch_schedule_time',
      align: 'center',
      width: 180,
      sorter: (a, b) => new Date(a?.batch_schedule_time) - new Date(b?.batch_schedule_time), // ✅ date sorting
      render: (data) => (
        <Tooltip title={data} placement="top">
          <div className="truncate w-full">{data?.slice(0, 16)}</div>
        </Tooltip>
      ),
    },
    {
      title: selectedModule === 'prod' ? 'BMR Size' : `${'BPR'} ${'Size'}`,
      dataIndex: 'batch_size',
      key: 'batch_size',
      align: 'center',
      width: 120,
      sorter: (a, b) => Number(a?.batch_size) - Number(b?.batch_size), // ✅ numeric sorting
      render: (text) => (
        <Tooltip title={text} placement="top">
          <div className="truncate w-full">{text}</div>
        </Tooltip>
      ),
    },
    // {
    //   title: "Machine",
    //   dataIndex: "machine",
    //   key: "machine",
    //   align: "center",
    // },
    // {
    //   title: "Start Time",
    //   dataIndex: "batch_start_time",
    //   key: "id",
    //   align: "center",
    //   render: (data) => {
    //     // return formatDate(data);
    //     if (data !== "None") {
    //       return data?.slice(0, 16);
    //     } else {
    //       return <HourglassEmptyIcon color="warning" />;
    //     }
    //   },
    // },
    // ...selectedIndustry === "Pharma" &&
    // (
    //   schedulingAccess?.update_access
    //     ? [
    //         {
    //           title: "Released",
    //           key: "id",
    //           align: "center",
    //           render: (data, record, index) => {
    //             return (
    //               <Tooltip title="Check Flow">
    //                 <Button
    //                   type="default"
    //                   size="small"
    //                   type="default"
    //                   className="bg-blue-500 text-white hover:bg-blue-600"
    //                   startIcon={<SendTimeExtensionIcon />}
    //                   onClick={() => {
    //                     navigate("/initialProdFlow", {
    //                       state: {
    //                         batch_number: record?.batch_number,
    //                         recipe: record?.recipe_id,
    //                         recipeName: record?.recipe_name,
    //                         machine_id: record?.machine_id,
    //                         productName: record?.product_name,
    //                       },
    //                     });
    //                   }}
    //                 >
    //                   Check Flow
    //                 </Button>
    //               </Tooltip>
    //             );
    //           },
    //         },
    //       ]
    //     : []
    // ),

    // {
    //   title: "Running Flow",
    //   dataIndex: "",
    //   key: "id",
    //   align: "center",
    //   render: (data, record) => {
    //     return (
    //       <IconButton
    //         onClick={() => {
    //           navigate("/continuous_prod", {
    //             state: record,
    //           });
    //         }}
    //       >
    //         <SchemaIcon color="primary" />
    //       </IconButton>
    //     );
    //   },
    // },

    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   key: "status",
    //   align: "center",
    //   render: (data, record, index) => {
    //     return (
    //       <IconButton
    //         onClick={() => {
    //           setShowGraph(true);
    //           setSelectedBatchForGraph(record.batch_number);
    //         }}
    //       >
    //         <SchemaIcon color="primary" />
    //       </IconButton>
    //     );
    //   },
    // },

    ...(tab_value === '6'
      ? [
          {
            title: 'Lots',
            dataIndex: 'lots',
            key: 'lots',
            align: 'center',
            width: 150,
            sorter: (a, b) => (a?.lots?.length || 0) - (b?.lots?.length || 0),
            render: (data, record, index) => {
              const lotsText = record?.lots?.join(', ') || '';
              return record?.lots?.length > 0 ? (
                <Tooltip title={lotsText} placement="top">
                  <div className="flex flex-wrap gap-1 max-h-6 overflow-hidden">
                    {record?.lots?.slice(0, 2).map((lot, idx) => (
                      <Tag key={idx} color="blue" className="text-xs px-2 truncate">
                        {lot?.length > 6 ? lot.slice(0, 6) + '…' : lot}
                      </Tag>
                    ))}
                    {record?.lots?.length > 2 && (
                      <span className="text-xs text-gray-500">+{record.lots.length - 2}</span>
                    )}
                  </div>
                </Tooltip>
              ) : (
                ''
              );
            },
          },
          {
            title: 'Status',
            key: 'id',
            width: 120,
            align: 'center',
            render: (data, record, index) => {
              if (record?.completion_status) {
                return (
                  <Tooltip title="Execution Completed">
                    <VerifiedIcon className="text-green-600 text-[20px] transition-all duration-200 hover:text-[24px]" />
                  </Tooltip>
                );
              }
              // if (record?.remainning_size > 0) {
              //   return (
              //     <Stack
              //       direction="row"
              //       spacing={1}
              //       alignItems="center"
              //       justifyContent="center"
              //     >
              //       <Popconfirm
              //         title={
              //           <Stack spacing={1} style={{ width: "300px" }}>
              //             <Typography>
              //               Are you certain you want to create lot for this BMR
              //               batch?
              //             </Typography>
              //           </div>
              //         }
              //         placement="bottom"
              //         onConfirm={() => {
              //           set_master_batch_number(record);
              //           set_is_schedule_lot(true);
              //         }}
              //         okText="Release"
              //         cancelText="Close"
              //         onCancel={() => {
              //           set_employee([]);
              //         }}
              //         okButtonProps={{
              //           style: {
              //             backgroundColor: "#3b82f6", // Tailwind blue-500
              //             color: "#ffffff", // White text
              //             borderColor: "#3b82f6", // Optional: border same as bg
              //           },
              //         }}
              //         cancelButtonProps={{
              //           className:
              //             "bg-blue-600 text-white hover:bg-blue-700 border-none",
              //         }}
              //       >
              //         <Tooltip title="Create lot for this BMR Batch">
              //           <IconButton
              //             size="small"
              //             disabled={!record?.remainning_size > 0}
              //           >
              //             <LibraryAddIcon
              //               className={`transition-transform duration-200 cursor-pointer text-[26px] hover:text-[30px] ${
              //                 record?.remainning_size > 0
              //                   ? "text-blue-500"
              //                   : "text-gray-400"
              //               }`}
              //             />
              //           </IconButton>
              //         </Tooltip>
              //       </Popconfirm>
              //     </div>
              //   );
              // }
              else {
                return (
                  <Tooltip title="In Progress">
                    <AccessTimeIcon
                      style={{
                        fontSize: 20,
                        color: 'orange',
                        transition: 'all 0.2s ease',
                        '&:hover': {
                          fontSize: 24,
                        },
                      }}
                    />
                  </Tooltip>
                );
              }
            },
          },
        ]
      : []),

    // ...get_view_function1(),

    accessControlUtils('BMR Tracking')?.delete_access &&
      tab_value !== '6' && {
        title: 'Actions',
        key: 'action',
        align: 'center',
        fixed: 'right',
        width: 120,
        render: (_, record) => (
          <div className="gap-2">
            <Tooltip title="View Batch Report">
              <button
                onClick={() => {
                  set_current_batch(record?.batch_number);
                  if (record?.lots && record?.lots.length > 0) {
                    getParentLotBatchDetails(record?.batch_number);
                  } else {
                    getBatchReportData(record?.batch_number);
                  }
                  set_selected_recipe(record?.recipe_name);
                  setReportView(true);
                }}
                className="p-1 mx-1 rounded-md bg-blue-500 text-white transition-transform duration-200 hover:bg-blue-600 hover:scale-110"
              >
                <Icons.Eye className="w-5 h-5" />
              </button>
            </Tooltip>

            {/* Terminate Batch (Popconfirm + normal button) */}
            <Popconfirm
              title="Are you sure you want to terminate this Batch?"
              onConfirm={() => handleTerminate(record)}
              okText="Yes"
              cancelText="No"
              placement="left"
              className="mx-1"
            >
              <Tooltip title="Terminate Batch">
                <button className="p-1 rounded-md bg-red-500 text-white transition-transform duration-200 hover:bg-red-600 hover:scale-110">
                  <Icons.StopCircle className="w-5 h-5" />
                </button>
              </Tooltip>
            </Popconfirm>
          </div>
        ),
      },

    // {
    //   title: "Edit Batch",
    //   dataIndex: "",
    //   key: "batch_schedule_time",
    //   align: "center",
    //   render: (data, record, index) => {
    //     return (
    //       <>
    //         <Button
    //           onClick={() => {
    //             navigate("/edit-batch", {
    //               state: {
    //                 batch_number: record?.batch_number,
    //                 recipe: 242,
    //                 recipeName: record?.recipe_name,
    //               },
    //             });
    //           }}
    //         >
    //           Edit
    //         </Button>
    //       </>
    //     );
    //   },
    // },
  ].filter(Boolean);

  const batch_start_columns = [
    {
      title: selectedModule === 'prod' ? 'MBMR' : 'MBPR',
      dataIndex: 'recipe_name',
      key: 'id',
      align: 'center',
      width: 150,
      filteredValue: [searchvalue],
      sorter: (a, b) => a?.recipe_name?.localeCompare(b?.recipe_name), // ✅ sorting
      onFilter: (value, record) => {
        return (
          String(record.recipe_name).toLowerCase().includes(value.toLowerCase()) ||
          String(record.batch_number).toLowerCase().includes(value.toLowerCase())
        );
      },
      render: (text) => (
        <Tooltip title={text} placement="top">
          <div className="truncate w-full">{text}</div>
        </Tooltip>
      ),
    },
    {
      title: selectedModule === 'prod' ? 'BMR' : 'BPR',
      dataIndex: 'batch_number',
      key: 'id',
      align: 'center',
      width: 150,
      sorter: (a, b) => a?.batch_number?.localeCompare(b?.batch_number), // ✅ sorting
      render: (text) => (
        <Tooltip title={text} placement="top">
          <div className="truncate w-full">{text}</div>
        </Tooltip>
      ),
    },
    {
      title: selectedModule === 'prod' ? 'BMR Size' : 'BPR Size',
      dataIndex: 'batch_size',
      key: 'batch_size',
      align: 'center',
      width: 150,
      sorter: (a, b) => a?.batch_size - b?.batch_size, // ✅ numeric sorting
      render: (text) => (
        <Tooltip title={text} placement="top">
          <div className="truncate w-full">{text}</div>
        </Tooltip>
      ),
    },
    project_type === 'pharma' && {
      title: 'Lots',
      dataIndex: 'lots',
      key: 'lots',
      align: 'center',
      width: 150,
      sorter: (a, b) => (a?.lots?.length || 0) - (b?.lots?.length || 0), // ✅ sorting
      render: (__, record) => {
        const lotsText = record?.lots?.join(', ') || '';
        return (
          <Tooltip title={lotsText} placement="top">
            <div className="flex flex-wrap justify-center gap-1 max-h-6 overflow-hidden">
              {record?.lots?.slice(0, 2).map((lot, idx) => (
                <Tag key={idx} color="blue" className="text-xs px-2 truncate">
                  {lot?.length > 6 ? lot.slice(0, 6) + '…' : lot}
                </Tag>
              ))}
              {record?.lots?.length > 2 && (
                <span className="text-xs text-gray-500">+{record.lots.length - 2}</span>
              )}
            </div>
          </Tooltip>
        );
      },
    },
    project_type !== 'pharma' && {
      title: 'Machine',
      dataIndex: 'machine',
      key: 'machine',
      align: 'center',
      width: 120,
      sorter: (a, b) => a?.machine?.localeCompare(b?.machine), // ✅ sorting
      render: (text) => (
        <Tooltip title={text} placement="top">
          <div className="truncate w-full">{text}</div>
        </Tooltip>
      ),
    },
    project_type !== 'pharma' && {
      title: 'Schedule Time',
      dataIndex: 'batch_schedule_time',
      key: 'schedule_time',
      align: 'center',
      sorter: (a, b) => new Date(a?.batch_schedule_time) - new Date(b?.batch_schedule_time), // ✅ date sorting
      width: 200,
      render: (data, record, index) => {
        if (scheduleTimeEdit[index]?.status) {
          return (
            <div className="w-full">
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '8px',
                  justifyContent: 'center',
                }}
              >
                <OutlinedInput
                  id="des"
                  type="datetime-local"
                  size="small"
                  name="des"
                  value={
                    scheduleTimeEdit[index]?.value?.slice(0, 19) ||
                    batch_data?.schedule_list[index]?.batch_schedule_time?.slice(0, 19)
                  }
                  fullWidth
                  inputProps={{
                    min: batch_data?.schedule_list[index]?.batch_schedule_time?.slice(0, 19),
                  }}
                  disabled={!scheduleTimeEdit[index]?.status}
                  //   onClick={() => setIsScheduledDateEdit(true)} // Set isEditing to true on click
                  onChange={(e) => {
                    const updatedScheduleTimeStatus = [...scheduleTimeEdit];
                    updatedScheduleTimeStatus[index].value = formatDate(e.target.value);
                    setScheduleTimeEdit(updatedScheduleTimeStatus);
                  }}
                />
                {schedulingAccess?.create_access && (
                  <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                    <Tooltip title="Close">
                      <IconButton
                        size="small"
                        onClick={() => {
                          const updatedScheduleTimeStatus = [...scheduleTimeEdit];
                          updatedScheduleTimeStatus[index].status = false;
                          // updatedScheduleTimeStatus[index].value = "";
                          setScheduleTimeEdit(updatedScheduleTimeStatus);
                        }}
                      >
                        <CancelIcon color="error" fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Popconfirm
                      title={'Are you sure you want to reschedule batch?'}
                      placement="bottom"
                      onConfirm={() => {
                        const updatedScheduleTimeStatus = [...scheduleTimeEdit];
                        updatedScheduleTimeStatus[index].status = false;
                        setScheduleTimeEdit(updatedScheduleTimeStatus);
                        const req = {
                          batch_number: record?.batch_number,
                          batch_schedule_time: updatedScheduleTimeStatus[index]?.value?.slice(
                            0,
                            19
                          ),
                        };
                        update_scheduleTime(req);
                      }}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Tooltip title="Update">
                        <IconButton size="small" disabled={scheduleTimeEdit[index]?.value === ''}>
                          <CheckCircleIcon
                            fontSize="small"
                            color={scheduleTimeEdit[index]?.value !== '' ? 'success' : 'secondary'}
                          />
                        </IconButton>
                      </Tooltip>
                    </Popconfirm>
                  </div>
                )}
              </div>
            </div>
          );
        } else {
          const dateObject = new Date(data);

          return (
            <Tooltip title={data} placement="top">
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: '8px',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
                className="w-full"
              >
                <span className="truncate flex-1">{data?.slice(0, 16)}</span>
                {schedulingAccess?.update_access && (
                  <Tooltip title="Reschedule Batch">
                    <IconButton
                      size="small"
                      onClick={() => {
                        const updatedScheduleTimeStatus = [...scheduleTimeEdit];
                        updatedScheduleTimeStatus[index].status = true;
                        setScheduleTimeEdit(updatedScheduleTimeStatus);
                      }}
                    >
                      <BorderColorRoundedIcon color="primary" fontSize="small" />
                    </IconButton>
                  </Tooltip>
                )}
              </div>
            </Tooltip>
          );
        }
      },
    },

    // ...(selectedIndustry === "Pharma" &&
    // schedulingAccess?.update_access
    //   ? [
    //       {
    //         title: "Release",
    //         key: "id",
    //         align: "center",
    //         render: (data, record, index) => {
    //           if (record?.batch_type === "Parent") return null;
    //           return record?.is_release ? (
    //             <Tooltip title="Check Flow">
    //               <Button
    //                 type="default"
    //                 size="small"
    //                 type="default"
    //                 className="bg-blue-500 text-white hover:bg-blue-600"
    //                 startIcon={<SendTimeExtensionIcon />}
    //                 onClick={() => {
    //                   navigate("/initialProdFlow", {
    //                     state: {
    //                       batch_number: record?.batch_number,
    //                       recipe: record?.recipe_id,
    //                       recipeName: record?.recipe_name,
    //                       machine_id: record?.machine_id,
    //                       productName: record?.product_name,
    //                     },
    //                   });
    //                 }}
    //               >
    //                 Check Flow
    //               </Button>
    //             </Tooltip>
    //           ) : (
    //             <Button
    //               size="small"
    //               type="default"
    //               // disabled={!record?.active_status}
    //               className="bg-blue-500 text-white hover:bg-blue-600"
    //               startIcon={<PlayCircleFilledIcon />}
    //               onClick={() => {
    //                 // for dispencing
    //                 process_scheduling_config_data(record?.batch_number);
    //                 dispensing_scheduling_config_data(record?.batch_number);
    //                 navigate("/initialProdFlow", {
    //                   state: {
    //                     batch_number: record?.batch_number,
    //                     recipe: record?.recipe_id,
    //                     recipeName: record?.recipe_name,
    //                     machine_id: record?.machine_id,
    //                     productName: record?.product_name,
    //                   },
    //                 });
    //               }}
    //             >
    //               Start
    //             </Button>
    //           );
    //         },
    //       },
    //     ]
    //   : [

    // Merged Actions Column - combines both action columns into one
    (schedulingAccess?.update_access || schedulingAccess?.delete_access) && {
      title: 'Actions',
      key: 'actions',
      fixed: 'right',
      align: 'center',
      width: 100,
      render: (data, record, index) => {
        return (
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              gap: '8px',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            className="w-full flex-wrap gap-1"
          >
            {/* Update/Create/Start Actions */}
            {schedulingAccess?.update_access && (
              <>
                {project_type !== 'pharma' && (
                  <Popconfirm
                    title={
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '8px',
                          width: '300px',
                        }}
                      >
                        <Typography>
                          Are you certain you want to assign the employees to every process and
                          operation?
                        </Typography>
                        <AntSelect
                          allowClear
                          showSearch
                          mode="multiple"
                          value={employee}
                          style={{ width: '100%' }}
                          required
                          optionFilterProp="children"
                          placeholder="Select Employees"
                          onChange={(value) => set_employee(value)}
                        >
                          {bulk_assign_list?.map((mdata) => (
                            <AntSelect.Option key={mdata.employee_id} value={mdata.employee_id}>
                              {mdata.employee_name}
                            </AntSelect.Option>
                          ))}
                        </AntSelect>
                      </div>
                    }
                    placement="bottom"
                    onConfirm={() => {
                      post_api_function(
                        '/update_all_employee_to_batch',
                        success_assign_all_employee,
                        {
                          batch_number: current_batch,
                          employee_id: employee,
                        }
                      );
                    }}
                    okText="Assign"
                    cancelText="Close"
                    onCancel={() => {
                      set_employee([]);
                    }}
                    okButtonProps={{
                      disabled: employee?.length === 0,
                    }}
                  >
                    <Tooltip title="Assign Employees To All Process">
                      <IconButton
                        size="small"
                        variant="contained"
                        //className="bg-blue-500"
                        disabled={current_expand !== record?.key}
                        color="primary"
                      >
                        <GroupAddIcon
                          style={{
                            fontSize: '20px',
                            color: current_expand !== record?.key ? '#9ca3af' : '#3b82f6',
                            transition: 'all 0.2s ease',
                            '&:hover': {
                              fontSize: 22,
                            },
                          }}
                        />
                      </IconButton>
                    </Tooltip>
                  </Popconfirm>
                )}

                <Popconfirm
                  title={
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '8px',
                        width: '300px',
                      }}
                    >
                      <Typography>
                        Are you certain you want to create lot for this BMR batch?
                      </Typography>
                    </div>
                  }
                  placement="bottom"
                  onConfirm={() => {
                    set_master_batch_number(record);
                    setMinMaxBatchSize({
                      actual: record?.actual_quantity,
                    });
                    set_is_schedule_lot(true);
                    set_show_add_schedule(false);
                  }}
                  okText="Release"
                  cancelText="Close"
                  onCancel={() => {
                    set_employee([]);
                  }}
                  okButtonProps={{
                    style: {
                      backgroundColor: '#3b82f6',
                      color: '#ffffff',
                      borderColor: '#3b82f6',
                    },
                  }}
                >
                  <Tooltip title="Create lot for this BMR Batch">
                    <IconButton size="small">
                      <LibraryAddIcon
                        style={{
                          color: '#16a34a',
                          fontSize: '20px',
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                </Popconfirm>

                {project_type !== 'pharma' && (
                  <Popconfirm
                    title={
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '8px',
                          width: '300px',
                        }}
                      >
                        <Typography>Are you certain you want to Start this BMR?</Typography>
                      </div>
                    }
                    placement="left"
                    onConfirm={() => {
                      set_selectedBatchId(record?.batch_id);
                      set_batch_numberNew(record?.batch_number);
                      set_machine_idNew(record?.machine_id);
                      start_batch(record?.batch_id);
                    }}
                    okText="Start"
                    cancelText="Close"
                    onCancel={() => {
                      set_employee([]);
                    }}
                    okButtonProps={{
                      style: {
                        backgroundColor: '#3b82f6',
                        color: '#ffffff',
                        borderColor: '#3b82f6',
                      },
                    }}
                  >
                    <Tooltip title="Start">
                      <button
                        className={`flex items-center justify-center p-1 rounded-md transition-transform duration-200 hover:scale-110 ${
                          record?.active_status
                            ? 'bg-green-500 text-white hover:bg-green-600'
                            : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                        }`}
                        disabled={!record?.active_status}
                        onClick={() => {
                          if (record?.active_status) {
                            // your start logic here
                          }
                        }}
                      >
                        <Icons.PlayCircle className="w-5 h-5" />
                      </button>
                    </Tooltip>
                  </Popconfirm>
                )}
              </>
            )}

            {/* Delete Action */}
            {schedulingAccess?.delete_access && (
              <Popconfirm
                title={'Are you sure you want to delete this batch?'}
                placement="left"
                onConfirm={() => {
                  delete_batchDetails({
                    batch_number: record?.batch_number,
                  });
                }}
                okText="Yes"
                cancelText="No"
                okButtonProps={{
                  className: 'bg-blue-600 text-white hover:bg-blue-700 border-none',
                }}
                cancelButtonProps={{
                  className: 'bg-blue-600 text-white hover:bg-blue-700 border-none',
                }}
              >
                <Tooltip title="Delete Batch">
                  <button className="flex items-center justify-center p-1 rounded-md text-red-600 transition-transform duration-200 hover:scale-110">
                    <Icons.Trash2 className="w-5 h-5" />
                  </button>
                </Tooltip>
              </Popconfirm>
            )}
          </div>
        );
      },
    },
  ].filter(Boolean);

  const add_schedule = (lot_batch_type) => (
    <Scheduling
      refresh={refresh}
      set_refresh={set_refresh}
      selectedButton={selectedButton}
      set_view_bom_data={set_view_bom_data}
      setIsBomVisible={setIsBomVisible}
      setMinMaxBatchSize={setMinMaxBatchSize}
      setBatchSize={setBatchSize}
      batch_type={lot_batch_type || batch_type}
      masterBatch={master_batch}
      selectedLots={selectedLots}
      setSelectedLots={setSelectedLots}
    />
  );

  const get_all_batchDetails = async () => {
    try {
      // await bp_get_batch_details(
      //   success_bp_get_batch_details,
      //   selectedButton === "production" ? { recipe_type: true } : {}
      // );

      const req =
        selectedButton === 'production'
          ? {
              recipe_type: true,
              start_time: fromDate,
              end_time: toDate,
              page_number: page_number,
              module_type: selectedModule,
              ...(searchvalue && { search: searchvalue }),
              ...(selectedRecipe && { recipe_id: selectedRecipe }),
            }
          : fromDate && toDate
          ? {
              start_time: fromDate,
              end_time: toDate,
              page_number: page_number,
              module_type: selectedModule,
              ...(searchvalue && { search: searchvalue }),
              ...(selectedRecipe && { recipe_id: selectedRecipe }),
            }
          : {
              page_number: page_number,
              module_type: selectedModule,
              ...(searchvalue && { search: searchvalue }),
              ...(selectedRecipe && { recipe_id: selectedRecipe }),
            };

      set_loading(true);

      switch (tab_value) {
        case '1':
          await get_schedule_batch_details(
            { ...req, project_type: 'pharma' },
            success_bp_get_batch_details
          );
          break;

        case '2':
          await get_running_batch_details(req, success_bp_get_batch_details);
          break;

        case '3':
          if (isReject) {
            await get_api_function('/get_rejected_batche', success_bp_get_batch_details, req);
          } else {
            await get_completed_batch_details(req, success_bp_get_batch_details);
          }
          break;

        case '4':
          await get_batch_copy_details(
            {
              ...(searchvalue && { search_item: searchvalue }),
              ...(selectedRecipe && { recipe_id: selectedRecipe }),
              page_number: page_number,
            },
            success_bp_get_copy_details
          );
          break;
        case '6':
          await get_parent_batch_details(success_bp_get_batch_details);
          break;
        case '7':
          setSeparateQrLoading(true);
          await get_seperate_qr_details(
            {
              page_number: separateQrPage,
              ...(separateQrSearch && { search_item: separateQrSearch }),
            },
            (res) => {
              if (res?.data?.status === 'success') {
                setSeparateQrData(res.data.data || []);
                setSeparateQrTotal(res.data.obj_count || 0);
                setSeparateQrMaxPage(res.data.max_page_number || 1);
              }
              setSeparateQrLoading(false);
            }
          );
          break;
        case '8':
          await get_release_approval_details(req, (res) => {
            if (res?.data?.status === 'success') {
              const data = res?.data?.data;
              set_approval_data(data);
              setTotal(res?.data?.obj_count);
              set_loading(false);
            }
          });
          break;

        default:
          console.warn('Unhandled tab_value:', tab_value);
          break;
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const success_bp_get_copy_details = (res) => {
    if (res?.data?.status === 'success') {
      setModifiedData(res?.data?.data);
      set_loading(false);
      setTotal(res?.data?.obj_count);
    } else {
      set_loading(false);
    }
  };

  const success_bp_get_batch_details = (res) => {
    if (res?.data?.status === 'success') {
      const data = res?.data?.data[0];
      set_batch_data(data);
      setTotal(res?.data?.obj_count);
      set_loading(false);
      const reqList = data?.schedule_list?.map((item, index) => {
        return {
          status: false,
          value: item?.batch_schedule_time,
        };
      });
      setScheduleTimeEdit(reqList);

      if (datashow_lot_number && datashow_lot_number?.bmr) {
        if (datashow_lot_number?.status === 'Completed') {
          const indexKey = data?.completed_list?.findIndex(
            (item) => item?.batch_number === datashow_lot_number?.bmr
          );
          const done_batch = indexKey !== -1 ? data?.completed_list[indexKey] : null;
          setSelectedRowKeys(indexKey);
          handleRowSelectionChange(indexKey, [done_batch]);
        } else if (
          datashow_lot_number?.status === 'In Process' &&
          data?.running_list &&
          data?.running_list?.length > 0
        ) {
          const indexKey = data?.running_list?.findIndex((item) => item?.batch_number);
          const done_batch = indexKey !== -1 ? data?.running_list[indexKey] : null;
          setSelectedRowKeys(indexKey);
          handleRowSelectionChange(indexKey, [done_batch]);
        } else {
          const indexKey = data?.schedule_list?.findIndex((item) => item?.batch_number);

          const done_batch = indexKey !== -1 ? data?.schedule_list[indexKey] : null;
          setSelectedRowKeys([indexKey]);
          handleRowSelectionChange(indexKey, [done_batch]);
        }
      }
    } else {
      set_loading(false);
    }
  };

  const get_batch_changesDetails = async (recipe_id) => {
    try {
      await get_batch_changes_details(
        { recipe_id: recipe_id },
        success_bp_get_batch_changes_details
      );
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const success_bp_get_batch_changes_details = (res) => {
    if (res?.data?.message !== 'Data Retrived Successfully') {
      toast?.success(res?.data.message);
    }
    set_modified_details(addKeysInFilterDataForCollapse(res?.data?.data || []));
  };

  const process_scheduling_config_data = async (batch_number) => {
    try {
      await process_scheduling_config({ batch_number: batch_number }, (res) => {
        if (res?.status === 'success') {
          toast.success(res.message);
        } else {
          toast.warning(res.message);
        }
      });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    try {
      const data = localStorage.getItem('user_access_data');
      if (data && data !== 'undefined' && data !== 'null') {
        set_user_access_data(JSON.parse(data));
      }
    } catch (error) {
      console.error('Error parsing user_access_data from localStorage:', error);
      localStorage.removeItem('user_access_data');
    }
    get_employee_list();
  }, []);

  useEffect(() => {
    get_summary_dashboard_data();
    get_all_batchDetails();
    setProductName('');
    set_is_schedule_lot(false);
  }, [refresh, selectedButton, tab_value, page_number, selectedButton, selectedModule]);

  useEffect(() => {
    if (selectedProcessId && current_batch) {
      if (tab_value === '2') {
        get_batch_details_by_process(selectedProcessId, current_batch);
      } else {
        //this is for refresh the scheduling while assigning or reassigning
        set_showSummary(false);
        get_batch_process_by_schedule(current_batch, currentExpandedbatchId);
        get_all_batchDetails();
        set_showSummary(true);
      }
    } else {
      if (current_batch && employee?.length > 0) {
        get_all_batchDetails();
        get_batch_process_by_schedule(current_batch, currentExpandedbatchId);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    assignStatus,
    currentExpandedbatchId,
    current_batch,
    employee?.length,
    selectedProcessId,
    tab_value,
  ]);

  useEffect(() => {
    if (view_bom_data?.recipe_id) {
      get_all_bom_data(view_bom_data);
    }
    get_recipe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [view_bom_data, selectedButton]);

  const view_operation_function = (process, batch) => {
    set_selectedProcessId(process?.process_id);
    set_selectedProcessName(process?.process_number);
    // get_batch_details_by_process(process?.process_id, batch || current_batch);
    set_showSummary(true);
  };

  const reset_date_range = () => {
    set_range_value([]);
    setFromDate();
    setToDate();
  };

  const handleRowSelectionChange = (selectedRowKeys, selectedRows) => {
    if (selectedRows?.length > 0) {
      setRowRecord(selectedRows[0]);
      setProductName(selectedRows[0]?.product_name);
    } else {
      setRowRecord({});
      setProductName('');
    }

    set_dag_batch(); // clear first

    setTimeout(() => {
      set_dag_batch(selectedRows[selectedRows?.length - 1]);
      setSelectedRowKeys([selectedRowKeys[selectedRowKeys?.length - 1]]);
    }, 1);
  };

  const rowSelection = {
    type: 'checkbox',
    onChange: handleRowSelectionChange,
    selectedRowKeys: selectedRowKeys,
    hideSelectAll: true,
  };

  const timeline = (reportData, comStatus) => {
    return (
      <>
        <Grid item xs={12} lg={12}>
          <Descriptions
            bordered
            size="middle"
            column={1}
            className="w-full max-w-xl bg-white p-1  mt-2"
            labelStyle={{ fontWeight: 600 }}
          >
            <Descriptions.Item label="MBMR">{selected_recipe}</Descriptions.Item>
            <Descriptions.Item label="BMR">{current_batch}</Descriptions.Item>
          </Descriptions>
          <div className="font-bold mt-2 p-1 ">Workflow:</div>
        </Grid>
        <Grid
          item
          lg={12}
          xs={12}
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '25px',
            maxHeight: '110vh',
            overflowY: 'scroll',
          }}
        >
          <Timeline
            items={reportData?.map((process, index_1) => ({
              //color: process?.operations?.length > 0 ? "green" : "red",
              color:
                process?.progress === 'Completed'
                  ? 'green'
                  : process?.progress === 'In Process'
                  ? 'orange'
                  : process?.progress === 'Pending' && 'red',
              // dot: (
              //   <ClockCircleOutlined
              //     style={{ color: "#FAAE2F", fontSize: "16px" }}
              //   />
              // ),

              children: !process?.parent_batch ? (
                <div
                  style={{
                    marginTop: '5px',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      gap: '8px',
                      alignItems: 'center',
                    }}
                  >
                    <Typography>
                      <b>{'Process: '}</b>
                      {`${process?.process_number}`}
                    </Typography>

                    {showSummaryIndex !== index_1 ? (
                      <Tooltip title="View Operations">
                        <IconButton
                          onClick={() => {
                            set_dag_nodes([`${process?.op_id}`]);
                            view_operation_function(process);
                            set_showSummaryIndex(index_1);
                          }}
                        >
                          <EyeOutlined
                            color={
                              process?.progress === 'Completed'
                                ? 'success'
                                : process?.progress === 'In Process'
                                ? 'warning'
                                : process?.progress === 'Pending' && 'error'
                            }
                            style={{ fontSize: '20px' }}
                          />
                        </IconButton>
                      </Tooltip>
                    ) : (
                      <Tooltip title="Close">
                        <IconButton
                          onClick={() => {
                            set_showSummary(false);
                          }}
                        >
                          <CloseOutlined color="primary" />
                        </IconButton>
                      </Tooltip>
                    )}
                  </div>
                </div>
              ) : (
                <div style={{ marginTop: '5px' }}>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      gap: '8px',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      color: textColor,
                    }}
                    className="text-sm"
                  >
                    {/* Left: Lot Info */}
                    <div className="flex flex-col gap-1">
                      <div>
                        <b>Lot Number:</b> {process?.lot_number}
                      </div>
                      <div>
                        <b>BMR Number:</b> {process?.batch_number}
                      </div>
                      <div>
                        <b>Quantity:</b> {process?.quantity}
                      </div>
                      {/* <div>
                        <b>Details:</b>
                        <Tooltip title="View Details">
                          <EyeOutlined
                            onClick={async () => {
                              setReportView(false);
                              set_datashow_lot_number({
                                bmr: process?.lot_number,
                                status: process?.progress,
                              });
                              if (process?.progress === "Completed") {
                                await set_tab_value("3");
                              } else if (process?.progress === "In Process") {
                                await set_tab_value("2");
                              } else {
                                await set_tab_value("1");
                              }
                            }}
                            className="cursor-pointer text-blue-600 hover:text-blue-800 transition-colors duration-200"
                          />
                        </Tooltip>
                      </div> */}
                      <div>
                        <b>Status:</b>
                        <span
                          className={`px-2 py-1 rounded text-xs font-medium ${
                            process.progress === 'Completed'
                              ? 'bg-green-100 text-green-700'
                              : process?.progress === 'In Process'
                              ? 'bg-yellow-100 text-yellow-700'
                              : 'bg-red-100 text-red-700'
                          }`}
                        >
                          {process?.progress}
                        </span>
                      </div>
                    </div>

                    {/* Right: View or Close Button */}
                    {showSummaryIndex !== index_1 ? (
                      <Tooltip title="View Lot Details">
                        <IconButton
                          onClick={() => {
                            set_dag_nodes([`${process?.lot_number}`]); // if needed
                            view_operation_function(process);
                            set_showSummaryIndex(index_1);
                          }}
                        >
                          {/* <EyeOutlined
                            color={
                              lot_status === "Completed"
                                ? "success"
                                : lot_status === "In Process"
                                ? "warning"
                                : "error"
                            }
                            style={{ fontSize: "20px" }}
                          /> */}
                        </IconButton>
                      </Tooltip>
                    ) : (
                      <Tooltip title="Close">
                        <IconButton onClick={() => set_showSummary(false)}>
                          <CloseOutlined color="primary" />
                        </IconButton>
                      </Tooltip>
                    )}
                  </div>
                </div>
              ),
            }))}
          />
        </Grid>
      </>
    );
  };

  const filterRecipe = () => {
    return (
      tab_value === '1' &&
      schedulingAccess?.create_access && (
        <Tooltip title={!show_add_schedule ? 'Schedule Batch' : 'Close'}>
          <button
            onClick={() => set_show_add_schedule(!show_add_schedule)}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-lg 
             text-sm font-medium text-white shadow-md 
             bg-[#204448] 
             transition-all duration-300 hover:scale-110"
          >
            {!show_add_schedule ? (
              <PlusOutlined className="text-white text-[15px]" />
            ) : (
              <CloseOutlined className="text-white text-[15px]" />
            )}
            Request Batch
          </button>
        </Tooltip>
      )
    );
  };

  const filters = (
    <div className="flex flex-row items-center gap-2">
      {tab_value === '1' && schedulingAccess?.create_access && (
        <Tooltip title={!show_add_schedule ? 'Schedule Batch' : 'Close'}>
          <button
            onClick={() => {
              set_show_add_schedule(!show_add_schedule);
              set_master_batch_number('master');
            }}
            className="inline-flex items-center justify-center gap-2 px-4 py-2 rounded-lg 
             text-sm font-medium text-white shadow-md 
             bg-[#204448] 
             transition-all duration-300 hover:opacity-90 h-[32px]"
          >
            {!show_add_schedule ? (
              <PlusOutlined className="text-white text-[15px]" />
            ) : (
              <CloseOutlined className="text-white text-[15px]" />
            )}
            {!show_add_schedule ? 'Request Batch' : 'Close'}
          </button>
        </Tooltip>
      )}
      <Popover
        content={
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <AntSelect
              showSearch
              allowClear
              id="demo-select-small"
              value={selectedRecipe || null}
              size="large"
              style={{
                minWidth: '200px',
                maxWidth: '300px',
                borderRadius: '3px',
              }}
              bordered
              placeholder="Select Recipe"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
              dropdownStyle={{
                minWidth: '250px',
                maxHeight: '400px',
                overflow: 'auto',
              }}
              onChange={(value, option) => {
                setSelectedRecipe(value);
              }}
              className="border-rounded-8"
            >
              {recipe_data?.map((mdata) => (
                <AntSelect.Option key={mdata.recipe_md_id} value={mdata.recipe_md_id}>
                  {mdata.recipe_md_name}
                </AntSelect.Option>
              ))}
            </AntSelect>

            <RangePicker
              format="YYYY-MM-DD"
              size="large"
              value={range_value}
              onChange={(value, dateString) => {
                setFromDate(dateString[0]);
                setToDate(dateString[1]);
                set_range_value(value);
              }}
            />
            <div
              style={{ display: 'flex', flexDirection: 'row', justifyContent: 'end', gap: '8px' }}
            >
              <Button
                variant="contained"
                type="primary"
                // disabled={!(range_value?.length > 0 || selectedRecipe)}
                size="small"
                onClick={() => {
                  setFromDate();
                  setToDate();
                  set_range_value();
                  set_refresh();
                  setSelectedRecipe();
                  set_refresh(!refresh);
                }}
                style={{
                  fontSize: '12px',
                  padding: '4px 19px',
                  minWidth: 'auto',
                }}
              >
                Reset
              </Button>
              <Button
                variant="contained"
                type="primary"
                // disabled={!(range_value?.length > 0 || selectedRecipe)}
                size="small"
                onClick={() => {
                  set_refresh(!refresh);
                }}
                style={{
                  fontSize: '12px',
                  padding: '4px 19px',
                  minWidth: 'auto',
                }}
              >
                Ok
              </Button>
            </div>
          </div>
        }
        placement="left"
        className="mx-w-70"
        trigger="click"
      >
        <Tooltip title="Filter">
          <button className="flex items-center justify-center w-8 h-8 rounded-md hover:bg-gray-100 transition-colors">
            <FilterAltIcon color="primary" style={{ fontSize: '20px' }} />
          </button>
        </Tooltip>
      </Popover>
      {tab_value === '3' && (
        <ButtonGroup
          type="default"
          aria-label="Basic button group"
          style={{ width: '140px' }}
          size="small"
        >
          <Button
            onClick={() => {
              setisReject(false);
              set_refresh(!refresh);
            }}
            style={buttonStyles(!isReject)}
          >
            All
          </Button>
          <Button
            onClick={() => {
              setisReject(true);
              set_refresh(!refresh);
            }}
            style={buttonStyles(isReject)}
          >
            Rejected
          </Button>
        </ButtonGroup>
      )}
    </div>
  );
  //############### handle Api's ################
  const getBatchReportData = async (batchNumber) => {
    try {
      await bp_get_batch_report_view(
        (res) => {
          if (res?.data?.status === 'success') {
            setReportData(res?.data?.data || []);
          } else {
            setReportData([]);
          }
        },
        { batch_number: batchNumber }
      );
    } catch (error) {
      console.error('Failed to fetch batch report:', error);
    } finally {
    }
  };

  const getParentLotBatchDetails = async (batchNumber) => {
    try {
      await get_parent_lot_batch_details({ batch_number: batchNumber }, (res) => {
        if (res?.data?.status === 'success') {
          setReportData(res?.data?.data || []);
        } else {
          setReportData([]);
        }
      });
    } catch (error) {
      console.error('Failed to fetch batch report:', error);
    } finally {
    }
  };

  return (
    <>
      <div style={{ width: '100%', padding: '0' }}>
        <Row gutter={[16, 16]} style={{ width: '100%', margin: 0 }}>
          <Col span={24}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <div
                style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '8px' }}
              >
                <Box
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    '& > *': {
                      m: 0,
                    },
                  }}
                >
                  {/* <ButtonGroup
                    type="default"
                    aria-label="Basic button group"
                    size="small"
                  >
                    <Button
                      onClick={() => handleClick("test")}
                      style={buttonStyles(selectedButton === "test")}
                    >
                      Test
                    </Button>
                    <Button
                      onClick={() => handleClick("production")}
                      style={buttonStyles(selectedButton === "production")}
                    >
                      Production
                    </Button>
                  </ButtonGroup> */}
                </Box>

                {tab_value === '2' && dag_batch && (
                  <>
                    <Form.Item
                      label={<span style={{ fontWeight: 'bold', color: 'gray' }}>Product</span>}
                    >
                      <div
                        style={{
                          width: 'auto',
                          minWidth: '180px',
                          minHeight: '30px',
                          padding: '5px 10px',

                          borderRadius: '3px',
                          backgroundColor: '#F5F5F5',
                          fontSize: '14px',
                        }}
                      >
                        {productName}
                      </div>
                    </Form.Item>
                    <Form.Item
                      label={<span style={{ fontWeight: 'bold', color: 'gray' }}>Recipe</span>}
                    >
                      <div
                        style={{
                          width: 'auto',
                          minWidth: '180px',
                          minHeight: '30px',
                          padding: '5px 10px',

                          borderRadius: '3px',
                          backgroundColor: '#F5F5F5',
                          fontSize: '14px',
                        }}
                      >
                        {rowRecord?.recipe_name || ''}
                      </div>
                    </Form.Item>
                  </>
                )}
              </div>
            </div>
          </Col>

          {dag_batch ? (
            <Col
              span={24}
              style={{
                border: '2px dashed #b3afaf',
                padding: '10px',
                borderRadius: '8px',
              }}
            >
              <DAGFlowCopy data={dag_batch} set_flow_data={reset_flow} />
            </Col>
          ) : (
            <Col span={24}>
              <CountDashboard summaryData={summaryData} />
            </Col>
          )}

          <Col span={24}>
            <Card
              title={
                <div className="flex items-center gap-2">
                  <Icons.FileText className="text-blue-600" size={24} />
                  <Title
                    level={4}
                    style={{
                      color: textColor,
                      margin: 0,
                      padding: 0,
                    }}
                  >
                    {t('BMR Details')}
                  </Title>
                </div>
              }
              className="m-0.5 border border-gray-300 shadow-md"
            >
              <Tabs
                activeKey={tab_value}
                size="small"
                tabBarStyle={{
                  backgroundColor: tabBgColor,
                  borderRadius: '8px',
                  padding: '2px 8px',
                  // marginBottom: 8,
                }}
                tabBarExtraContent={
                  <div
                    className="flex flex-row items-center gap-3 rounded-md p-2"
                    style={{ backgroundColor: sectionBgColor }}
                  >
                    {show_add_schedule ? null : (
                      <div
                        className="flex items-center gap-3 border-r pr-3"
                        style={{ borderColor: borderColor }}
                      >
                        <div className="flex items-center gap-1.5">
                          <span className="w-3 h-3 rounded-full bg-blue-500 inline-block" />
                          <span className="text-sm font-medium" style={{ color: textColor }}>
                            Master
                          </span>
                        </div>
                        <div className="flex items-center gap-1.5">
                          <span className="w-3 h-3 rounded-full bg-orange-500 inline-block" />
                          <span className="text-sm font-medium" style={{ color: textColor }}>
                            Lot
                          </span>
                        </div>
                      </div>
                    )}
                    <div className="flex items-center">{filters}</div>
                    <div className="flex items-center">
                      <ReusableSearchInput
                        placeholder="Search here..."
                        size="middle"
                        mt="2"
                        width={180}
                        value={searchvalue}
                        onSearch={() => get_all_batchDetails()}
                        onChange={(e) => setSearchvalue(e.target.value)}
                      />
                    </div>
                    <div className="flex items-center">
                      <InfoComponent title="BMR" content={'BMR Record Data'} />
                    </div>
                  </div>
                }
                onChange={(key) => {
                  set_page_number(1);
                  set_dag_batch();
                  setSelectedRowKeys([]);
                  setSearchvalue('');
                  setReportView(false);
                  set_tab_value(key);
                  set_datashow_lot_number('');
                  setSelectedRecipe('');
                  set_show_add_schedule(false);
                  reset_date_range();
                }}
                items={[
                  ...(accessControlUtils('BMR Details')?.read_access &&
                  schedulingAccess?.read_access
                    ? [
                        {
                          key: '1',
                          label: selectedModule === 'prod' ? 'Released BMR' : 'Released BPR',
                          children: (
                            <Row gutter={[8, 8]} style={{ width: '100%' }}>
                              <Col span={24}>
                                <div
                                  style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}
                                >
                                  {show_add_schedule && (
                                    <div
                                      className="rounded-lg p-5 hover:shadow-lg shadow-md transition-all duration-300"
                                      style={{
                                        border: `1px solid ${borderColor}`,
                                        backgroundColor: sectionBgColor,
                                      }}
                                    >
                                      <h3
                                        className="text-lg font-semibold mb-2"
                                        style={{ color: textColor }}
                                      >
                                        Request Batch
                                      </h3>
                                      {add_schedule()}
                                    </div>
                                  )}
                                  <div
                                    className="space-y-2 rounded-lg p-5 hover:shadow-lg shadow-md transition-all duration-300"
                                    style={{
                                      border: `1px solid ${borderColor}`,
                                      backgroundColor: sectionBgColor,
                                    }}
                                  >
                                    <h3
                                      className="text-lg font-semibold"
                                      style={{ color: textColor }}
                                    >
                                      BMR Records
                                    </h3>
                                    <Table
                                      bordered
                                      pagination={false}
                                      columns={batch_start_columns}
                                      loading={loading}
                                      expandable={
                                        project_type !== 'pharma' && {
                                          expandedRowRender: expandedRowRender,
                                          onExpand: handleExpand,
                                          expandedRowKeys: [current_expand],
                                          rowExpandable: (record) =>
                                            record?.batch_type !== 'Parent',
                                          expandIcon: ({ expanded, onExpand, record }) =>
                                            expanded ? (
                                              <button
                                                onClick={(e) => onExpand(record, e)}
                                                className="text-white text-xl bg-gray-500 hover:bg-green-600 rounded-full w-6 h-6 flex items-center justify-center"
                                              >
                                                −
                                              </button>
                                            ) : (
                                              <button
                                                onClick={(e) => onExpand(record, e)}
                                                className={`text-white text-xl rounded-full w-6 h-6 flex items-center justify-center ${
                                                  record?.batch_type === 'Master'
                                                    ? 'bg-blue-500 hover:bg-blue-600'
                                                    : record?.batch_type === 'Lot'
                                                    ? 'bg-orange-500 hover:bg-orange-600'
                                                    : record?.batch_type === 'Parent'
                                                    ? 'bg-green-500 hover:bg-green-600'
                                                    : 'bg-gray-400 hover:bg-gray-500'
                                                }`}
                                              >
                                                +
                                              </button>
                                            ),
                                        }
                                      }
                                      rowClassName={(record) => {
                                        if (record?.batch_type === 'Master') return 'bg-blue-50';
                                        if (record?.batch_type === 'Lot') return 'bg-orange-50';
                                        if (record?.batch_type === 'Parent') return 'bg-green-50';
                                        return 'bg-blue-50'; // default
                                      }}
                                      dataSource={addKeysInFilterDataForCollapse(
                                        batch_data?.schedule_list
                                      )}
                                      scroll={{ x: 'max-content' }}
                                    />
                                  </div>
                                  <div
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'row',
                                      justifyContent: 'end',
                                    }}
                                  >
                                    <Pagination
                                      total={total}
                                      showTotal={(total) => `Total ${total} BMR's`}
                                      pageSize={10}
                                      current={page_number}
                                      showSizeChanger={false}
                                      onChange={(value) => {
                                        set_page_number(value);
                                      }}
                                    />
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          ),
                        },
                      ]
                    : []),
                  ...[
                    {
                      key: '8',
                      label: selectedModule === 'prod' ? 'Release Approval' : 'Release Approval',
                      children: (
                        <Row gutter={[8, 8]} style={{ width: '100%' }}>
                          <Col span={24}>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                              <div
                                className="space-y-2 rounded-lg p-5 hover:shadow-lg shadow-md transition-all duration-300"
                                style={{
                                  border: `1px solid ${borderColor}`,
                                  backgroundColor: sectionBgColor,
                                }}
                              >
                                <h3 className="text-lg font-semibold" style={{ color: textColor }}>
                                  Release Approval
                                </h3>
                                <Table
                                  bordered
                                  loading={loading}
                                  pagination={false}
                                  columns={[
                                    {
                                      title: 'MBMR',
                                      dataIndex: 'recipe_name',
                                      key: 'mbmr',
                                      align: 'center',
                                      width: 150,
                                      sorter: (a, b) =>
                                        a?.recipe_name?.localeCompare(b?.recipe_name), // ✅ sorting
                                      render: (text) => (
                                        <Tooltip title={text} placement="top">
                                          <div className="truncate w-full">{text}</div>
                                        </Tooltip>
                                      ),
                                    },
                                    {
                                      title: 'BMR',
                                      dataIndex: 'batch_number',
                                      key: 'bmr',
                                      align: 'center',
                                      width: 150,
                                      sorter: (a, b) =>
                                        a?.batch_number?.localeCompare(b?.batch_number), // ✅ sorting
                                      render: (text) => (
                                        <Tooltip title={text} placement="top">
                                          <div className="truncate w-full">{text}</div>
                                        </Tooltip>
                                      ),
                                    },
                                    {
                                      title: 'Master/Lot',
                                      dataIndex: 'parent_number',
                                      key: 'masterLot',
                                      align: 'center',
                                      width: 120,
                                      sorter: (a, b) =>
                                        a?.parent_number?.localeCompare(b?.parent_number), // ✅ sorting
                                      render: (text) => (
                                        <Tooltip title={text} placement="top">
                                          <div className="truncate w-full">{text}</div>
                                        </Tooltip>
                                      ),
                                    },
                                    {
                                      title: 'Scheduled Time',
                                      dataIndex: 'batch_schedule_time',
                                      align: 'center',
                                      key: 'scheduledTime',
                                      width: 180,
                                      sorter: (a, b) =>
                                        new Date(a?.batch_schedule_time) -
                                        new Date(b?.batch_schedule_time), // ✅ date sorting
                                      render: (value) => (
                                        <Tooltip title={value} placement="top">
                                          <div className="truncate w-full">
                                            {value?.slice(0, 16)}
                                          </div>
                                        </Tooltip>
                                      ),
                                    },
                                    {
                                      title: 'BMR Size',
                                      dataIndex: 'batch_size',
                                      key: 'bmrSize',
                                      align: 'center',
                                      width: 120,
                                      sorter: (a, b) => a?.batch_size - b?.batch_size, // ✅ numeric sorting
                                      render: (text) => (
                                        <Tooltip title={text} placement="top">
                                          <div className="truncate w-full">{text}</div>
                                        </Tooltip>
                                      ),
                                    },
                                    {
                                      title: 'MBMR Details',
                                      key: 'mbmrDetails',
                                      align: 'center',
                                      width: 110,
                                      render: (_, record) => (
                                        <div className="flex justify-center">
                                          <Tooltip title="View MBMR Details">
                                            <Button
                                              type="text"
                                              className="transition-transform duration-200 hover:scale-125"
                                              icon={
                                                <Icons.ScrollText
                                                  size={20}
                                                  style={{ color: '#1890ff' }}
                                                />
                                              }
                                              onClick={() => {
                                                if (!record?.recipe_id) return;
                                                setMbmrModal({
                                                  open: true,
                                                  recipeId: record.recipe_id,
                                                  title: record?.recipe_name || 'MBMR Details',
                                                });
                                              }}
                                            />
                                          </Tooltip>
                                        </div>
                                      ),
                                    },
                                    {
                                      title: 'Actions',
                                      key: 'action',
                                      align: 'center',
                                      width: 120,
                                      render: (_, record) => (
                                        <div className="flex gap-2 justify-center items-center w-full">
                                          {/* Approve Button */}
                                          <Tooltip title="Approve">
                                            <button
                                              onClick={() => handleApprove(record)}
                                              className="flex items-center justify-center p-1 rounded-md bg-green-500 text-white transition-transform duration-200 hover:bg-green-600 hover:scale-110"
                                            >
                                              <Icons.Check size={16} />
                                            </button>
                                          </Tooltip>
                                          {/* Reject Button */}
                                          <Tooltip title="Reject">
                                            <button
                                              onClick={() => handleReject(record)}
                                              className="flex items-center justify-center p-1 rounded-md bg-red-500 text-white transition-transform duration-200 hover:bg-red-600 hover:scale-110"
                                            >
                                              <Icons.X size={16} />
                                            </button>
                                          </Tooltip>
                                        </div>
                                      ),
                                    },
                                  ]}
                                  dataSource={approval_data?.map((item, index) => ({
                                    ...item,
                                    key: index,
                                  }))}
                                  scroll={{ x: 'max-content' }}
                                />
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'end',
                                  }}
                                >
                                  <Pagination
                                    total={total}
                                    showTotal={(total) => `Total ${total} Requests`}
                                    pageSize={10}
                                    current={page_number}
                                    showSizeChanger={false}
                                    onChange={(value) => {
                                      set_page_number(value);
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      ),
                    },
                  ],
                  ...(accessControlUtils('BMR Details')?.read_access &&
                  accessControlUtils('Completed BMR')?.read_access
                    ? [
                        {
                          key: '3',
                          label: 'Completed',
                          children: (
                            <Row gutter={[8, 8]} style={{ width: '100%' }}>
                              <Col span={24}>{filterRecipe()}</Col>
                              <Col span={reportView ? 18 : 24}>
                                <div
                                  style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}
                                >
                                  <div
                                    className="space-y-2 rounded-lg p-5 hover:shadow-lg shadow-md transition-all duration-300"
                                    style={{
                                      border: `1px solid ${borderColor}`,
                                      backgroundColor: sectionBgColor,
                                    }}
                                  >
                                    <h3
                                      className="text-lg font-semibold"
                                      style={{ color: textColor }}
                                    >
                                      Completed BMR Records
                                    </h3>
                                    <Table
                                      bordered
                                      loading={loading}
                                      pagination={false}
                                      columns={completed_Batch_columns}
                                      dataSource={batch_data?.completed_list?.map(
                                        (item, index) => ({
                                          ...item,
                                          key: index,
                                        })
                                      )}
                                      rowClassName={(record) => {
                                        if (record?.batch_type === 'Master') return 'bg-blue-50';
                                        if (record?.batch_type === 'Lot') return 'bg-orange-50';

                                        return 'bg-blue-50'; // default
                                      }}
                                      scroll={{ x: 'max-content' }}
                                      rowSelection={{
                                        type: 'checkbox',
                                        onChange: (selectedRowKeys, selectedRows) => {
                                          set_dag_batch();
                                          setTimeout(() => {
                                            set_dag_batch(selectedRows[selectedRows?.length - 1]);
                                            setSelectedRowKeys([
                                              selectedRowKeys[selectedRowKeys?.length - 1],
                                            ]);
                                          }, 1);
                                        },
                                        selectedRowKeys: selectedRowKeys,
                                        hideSelectAll: true,
                                      }}
                                    />
                                    <div
                                      style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'end',
                                      }}
                                    >
                                      <Pagination
                                        total={total}
                                        showTotal={(total) => `Total ${total} BMR's`}
                                        pageSize={10}
                                        current={page_number}
                                        showSizeChanger={false}
                                        onChange={(value) => {
                                          set_page_number(value);
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </Col>
                              {reportView && (
                                <Drawer
                                  title="Details Panel"
                                  placement="right"
                                  width={420}
                                  onClose={() => setReportView(false)}
                                  open={reportView}
                                  bodyStyle={{ padding: 16 }}
                                  headerStyle={{
                                    background: '#165DFF',
                                    color: 'white',
                                  }}
                                >
                                  {timeline(reportData)}
                                </Drawer>
                              )}
                            </Row>
                          ),
                        },
                      ]
                    : []),
                  ...(accessControlUtils('BMR Details')?.read_access &&
                  accessControlUtils('Modified BMR')?.read_access &&
                  selectedModule === 'prod'
                    ? [
                        {
                          key: '4',
                          label: 'Modified Batches',
                          children: (
                            <Row gutter={[8, 8]} style={{ width: '100%' }}>
                              <Col span={24}>
                                <div
                                  style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}
                                >
                                  <div
                                    className="space-y-2 rounded-lg p-5 hover:shadow-lg shadow-md transition-all duration-300"
                                    style={{
                                      border: `1px solid ${borderColor}`,
                                      backgroundColor: sectionBgColor,
                                    }}
                                  >
                                    <div className="flex align-center justify-between">
                                      <h3
                                        className="text-lg font-semibold"
                                        style={{ color: textColor }}
                                      >
                                        Modified BMR Records
                                      </h3>
                                      <TableColumnConfig menu={columnConfigMenu} />
                                    </div>
                                    <Table
                                      bordered
                                      loading={loading}
                                      pagination={false}
                                      columns={modified_Batch_columns}
                                      dataSource={modifiedData}
                                      scroll={{ x: 'max-content' }}
                                    />
                                    <div
                                      style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'end',
                                      }}
                                    >
                                      <Pagination
                                        total={total}
                                        showTotal={(total) => `Total ${total} BMR's`}
                                        pageSize={10}
                                        current={page_number}
                                        showSizeChanger={false}
                                        onChange={(value) => {
                                          set_page_number(value);
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          ),
                        },
                      ]
                    : []),
                  ...(accessControlUtils('Completed Kittings')?.read_access &&
                  selectedModule === 'prod'
                    ? [
                        {
                          key: '5',
                          label: 'Completed Kittings',
                          children: (
                            <div
                              className="rounded-lg p-3 hover:shadow-lg shadow-md transition-all duration-300"
                              style={{
                                border: `1px solid ${borderColor}`,
                                backgroundColor: sectionBgColor,
                              }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  marginBottom: 8,
                                }}
                              >
                                <h3
                                  className="text-lg font-semibold"
                                  style={{ color: textColor, margin: 0 }}
                                >
                                  Kitting Records
                                </h3>
                                {kittingColumnMenu && (
                                  <TableColumnConfig menu={kittingColumnMenu} />
                                )}
                              </div>
                              <CompletedKitting
                                searchvalue={searchvalue}
                                selectedRecipe={selectedRecipe}
                                refresh={refresh}
                                onColumnMenu={setKittingColumnMenu}
                              />
                            </div>
                          ),
                        },
                      ]
                    : []),
                  ...(selectedModule === 'prod'
                    ? [
                        {
                          key: '6',
                          label: 'Master & Lots',
                          children: (
                            <Row gutter={[8, 8]} style={{ width: '100%' }}>
                              <Col span={24}>
                                <div
                                  className="rounded-lg p-3 hover:shadow-lg shadow-md transition-all duration-300"
                                  style={{
                                    border: `1px solid ${borderColor}`,
                                    backgroundColor: sectionBgColor,
                                  }}
                                >
                                  <h3
                                    className="text-lg font-semibold"
                                    style={{ color: textColor, margin: 0, marginBottom: 8 }}
                                  >
                                    Master/Lot Records
                                  </h3>
                                  <Table
                                    bordered
                                    loading={loading}
                                    pagination={false}
                                    columns={recipe_details_columns?.filter(Boolean)}
                                    dataSource={batch_data?.running_list?.map((item, index) => ({
                                      ...item,
                                      key: index,
                                    }))}
                                    scroll={{ x: 'max-content' }}
                                  />
                                  <div
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'row',
                                      justifyContent: 'end',
                                    }}
                                  >
                                    <Pagination
                                      total={total}
                                      showTotal={(total) => `Total ${total} BMR's`}
                                      pageSize={10}
                                      current={page_number}
                                      showSizeChanger={false}
                                      onChange={(value) => {
                                        set_page_number(value);
                                      }}
                                    />
                                  </div>
                                </div>
                              </Col>
                              {reportView && (
                                <Drawer
                                  title="Details Panel"
                                  placement="right"
                                  width={420}
                                  onClose={() => setReportView(false)}
                                  open={reportView}
                                  bodyStyle={{ padding: 16 }}
                                  headerStyle={{
                                    background: '#165DFF',
                                    color: 'white',
                                  }}
                                >
                                  {timeline(reportData)}
                                </Drawer>
                              )}
                            </Row>
                          ),
                        },
                      ]
                    : []),
                  ...(selectedModule === 'prod'
                    ? [
                        {
                          key: '7',
                          label: 'Separate Kitting',
                          children: (
                            <div
                              className="rounded-lg p-5 hover:shadow-lg shadow-md transition-all duration-300"
                              style={{
                                border: `1px solid ${borderColor}`,
                                backgroundColor: sectionBgColor,
                              }}
                            >
                              <div className="flex items-center justify-between mb-4">
                                <h3 className="text-lg font-semibold" style={{ color: textColor }}>
                                  Separate Kitting — QR Records
                                </h3>
                                <div className="flex gap-2">
                                  <Input
                                    placeholder="Search material, lot, QR no., batch..."
                                    prefix={<SearchOutlined />}
                                    value={separateQrSearch}
                                    allowClear
                                    style={{ width: 280 }}
                                    onChange={(e) => {
                                      const val = e.target.value;
                                      setSeparateQrSearch(val);
                                      if (!val) {
                                        setSeparateQrPage(1);
                                        setSeparateQrLoading(true);
                                        get_seperate_qr_details({ page_number: 1 }, (res) => {
                                          if (res?.data?.status === 'success') {
                                            setSeparateQrData(res.data.data || []);
                                            setSeparateQrTotal(res.data.obj_count || 0);
                                            setSeparateQrMaxPage(res.data.max_page_number || 1);
                                          }
                                          setSeparateQrLoading(false);
                                        });
                                      }
                                    }}
                                    onPressEnter={() => {
                                      setSeparateQrPage(1);
                                      setSeparateQrLoading(true);
                                      get_seperate_qr_details(
                                        {
                                          page_number: 1,
                                          ...(separateQrSearch && {
                                            search_item: separateQrSearch,
                                          }),
                                        },
                                        (res) => {
                                          if (res?.data?.status === 'success') {
                                            setSeparateQrData(res.data.data || []);
                                            setSeparateQrTotal(res.data.obj_count || 0);
                                            setSeparateQrMaxPage(res.data.max_page_number || 1);
                                          }
                                          setSeparateQrLoading(false);
                                        }
                                      );
                                    }}
                                  />
                                  <Button
                                    type="primary"
                                    icon={<SearchOutlined />}
                                    style={{
                                      backgroundColor: defaultColors.primary,
                                      borderColor: defaultColors.primary,
                                    }}
                                    onClick={() => {
                                      setSeparateQrPage(1);
                                      setSeparateQrLoading(true);
                                      get_seperate_qr_details(
                                        {
                                          page_number: 1,
                                          ...(separateQrSearch && {
                                            search_item: separateQrSearch,
                                          }),
                                        },
                                        (res) => {
                                          if (res?.data?.status === 'success') {
                                            setSeparateQrData(res.data.data || []);
                                            setSeparateQrTotal(res.data.obj_count || 0);
                                            setSeparateQrMaxPage(res.data.max_page_number || 1);
                                          }
                                          setSeparateQrLoading(false);
                                        }
                                      );
                                    }}
                                  >
                                    Search
                                  </Button>
                                  <Button
                                    icon={<ReloadOutlined />}
                                    onClick={() => {
                                      setSeparateQrPage(1);
                                      setSeparateQrSearch('');
                                      setSeparateQrLoading(true);
                                      get_seperate_qr_details({ page_number: 1 }, (res) => {
                                        if (res?.data?.status === 'success') {
                                          setSeparateQrData(res.data.data || []);
                                          setSeparateQrTotal(res.data.obj_count || 0);
                                          setSeparateQrMaxPage(res.data.max_page_number || 1);
                                        }
                                        setSeparateQrLoading(false);
                                      });
                                    }}
                                  >
                                    Refresh
                                  </Button>
                                </div>
                              </div>
                              <Table
                                bordered
                                loading={separateQrLoading}
                                pagination={false}
                                scroll={{ x: 'max-content' }}
                                dataSource={separateQrData.map((r) => ({ ...r, key: r.id }))}
                                columns={[
                                  {
                                    title: 'Material Name',
                                    dataIndex: 'material_name',
                                    key: 'material_name',
                                    width: 160,
                                  },
                                  {
                                    title: 'Material Unique ID',
                                    dataIndex: 'material_unique_id',
                                    key: 'material_unique_id',
                                    width: 150,
                                  },
                                  {
                                    title: 'Lot No.',
                                    dataIndex: 'lot_number',
                                    key: 'lot_number',
                                    width: 110,
                                  },
                                  {
                                    title: 'Batch No.',
                                    dataIndex: 'batch_number',
                                    key: 'batch_number',
                                    width: 110,
                                  },
                                  {
                                    title: 'QR Number',
                                    dataIndex: 'qr_number',
                                    key: 'qr_number',
                                    width: 130,
                                  },
                                  {
                                    title: 'QR Type',
                                    dataIndex: 'qr_type',
                                    key: 'qr_type',
                                    width: 110,
                                    align: 'center',
                                    render: (val) => (
                                      <Tag
                                        color={val === 'M' ? 'blue' : 'green'}
                                        style={{ fontWeight: 600 }}
                                      >
                                        {val === 'M'
                                          ? 'Mother'
                                          : val === 'C'
                                          ? 'Child'
                                          : val || '-'}
                                      </Tag>
                                    ),
                                  },
                                  {
                                    title: 'Quantity',
                                    dataIndex: 'quantity',
                                    key: 'quantity',
                                    width: 90,
                                    align: 'center',
                                  },
                                  {
                                    title: 'Pack 1',
                                    dataIndex: 'pack_1',
                                    key: 'pack_1',
                                    width: 90,
                                  },
                                  {
                                    title: 'Pack 2',
                                    dataIndex: 'pack_2',
                                    key: 'pack_2',
                                    width: 90,
                                  },
                                  {
                                    title: 'Gross Wt.',
                                    dataIndex: 'gross_weight',
                                    key: 'gross_weight',
                                    width: 100,
                                    align: 'center',
                                  },
                                  {
                                    title: 'Net Wt.',
                                    dataIndex: 'net_weight',
                                    key: 'net_weight',
                                    width: 100,
                                    align: 'center',
                                  },
                                  {
                                    title: 'Tare Wt.',
                                    dataIndex: 'tare_weight',
                                    key: 'tare_weight',
                                    width: 100,
                                    align: 'center',
                                  },
                                  {
                                    title: 'Mfg Date',
                                    dataIndex: 'open_date',
                                    key: 'open_date',
                                    width: 110,
                                    align: 'center',
                                  },
                                  {
                                    title: 'Expiry Date',
                                    dataIndex: 'expiry_date',
                                    key: 'expiry_date',
                                    width: 110,
                                    align: 'center',
                                  },
                                  {
                                    title: 'Created On',
                                    dataIndex: 'created_on',
                                    key: 'created_on',
                                    width: 150,
                                    align: 'center',
                                  },
                                  {
                                    title: 'Action',
                                    key: 'action',
                                    fixed: 'right',
                                    width: 100,
                                    align: 'center',
                                    render: (_, record) => (
                                      <Tooltip title="View & Reprint QR">
                                        <Button
                                          type="primary"
                                          size="small"
                                          icon={<PrinterOutlined />}
                                          style={{
                                            backgroundColor: defaultColors.primary,
                                            borderColor: defaultColors.primary,
                                          }}
                                          onClick={() => {
                                            setPreviewRecord(record);
                                            setPreviewModalVisible(true);
                                          }}
                                        >
                                          Reprint
                                        </Button>
                                      </Tooltip>
                                    ),
                                  },
                                ]}
                              />
                              <div className="flex justify-end mt-3">
                                <Pagination
                                  total={separateQrTotal}
                                  showTotal={(t) => `Total ${t} records`}
                                  pageSize={15}
                                  current={separateQrPage}
                                  showSizeChanger={false}
                                  onChange={(val) => {
                                    setSeparateQrPage(val);
                                    setSeparateQrLoading(true);
                                    get_seperate_qr_details(
                                      {
                                        page_number: val,
                                        ...(separateQrSearch && { search_item: separateQrSearch }),
                                      },
                                      (res) => {
                                        if (res?.data?.status === 'success') {
                                          setSeparateQrData(res.data.data || []);
                                          setSeparateQrTotal(res.data.obj_count || 0);
                                          setSeparateQrMaxPage(res.data.max_page_number || 1);
                                        }
                                        setSeparateQrLoading(false);
                                      }
                                    );
                                  }}
                                />
                              </div>
                            </div>
                          ),
                        },
                      ]
                    : []),
                ]?.filter(Boolean)}
              />
            </Card>
          </Col>
        </Row>
        {/* Separate Kitting — QR Preview & Reprint Modal */}
        <Modal
          open={previewModalVisible}
          title={
            <div className="flex items-center gap-2">
              <PrinterOutlined />
              <span>QR Label Preview</span>
              {previewRecord && (
                <Tag
                  color={previewRecord.qr_type === 'M' ? 'blue' : 'green'}
                  style={{ fontSize: 14, fontWeight: 700, padding: '2px 10px', marginLeft: 8 }}
                >
                  {previewRecord.qr_type === 'M' ? 'Master (M)' : 'Child (C)'}
                </Tag>
              )}
            </div>
          }
          width={680}
          onCancel={() => {
            setPreviewModalVisible(false);
            setPreviewRecord(null);
          }}
          footer={[
            <Button
              key="cancel"
              onClick={() => {
                setPreviewModalVisible(false);
                setPreviewRecord(null);
              }}
            >
              Cancel
            </Button>,
            <Button
              key="print"
              type="primary"
              icon={<PrinterOutlined />}
              loading={reprintLoading === previewRecord?.id}
              style={{ backgroundColor: defaultColors.primary, borderColor: defaultColors.primary }}
              onClick={() => {
                if (!previewRecord) return;
                setReprintLoading(previewRecord.id);
                reprint_seperate_qr({ qr_id: previewRecord.id }, (res) => {
                  if (res?.data?.status === 'success') {
                    toast.success('QR Reprinted Successfully');
                    setPreviewModalVisible(false);
                    setPreviewRecord(null);
                  } else {
                    toast.error(res?.data?.message || 'Reprint failed');
                  }
                  setReprintLoading(null);
                });
              }}
            >
              Confirm & Print
            </Button>,
          ]}
          zIndex={1500}
        >
          {previewRecord && (
            <div>
              <div className="flex gap-6 items-start">
                <div className="flex flex-col items-center gap-2" style={{ minWidth: 150 }}>
                  <AntQRCode
                    value={`${previewRecord.material_unique_id}-${previewRecord.batch_number}-${previewRecord.quantity}-${previewRecord.pack_1}/${previewRecord.pack_2}-R-${previewRecord.qr_number}-${previewRecord.ingredent_material_id}-${previewRecord.lot_number}-${previewRecord.open_date}-${previewRecord.expiry_date}-${previewRecord.quantity}`}
                    size={140}
                    style={{ border: '1px solid #d9d9d9', borderRadius: 6 }}
                  />
                  <span
                    style={{
                      fontSize: 11,
                      color: '#888',
                      textAlign: 'center',
                      wordBreak: 'break-all',
                      maxWidth: 150,
                    }}
                  >
                    {previewRecord.qr_number}
                  </span>
                </div>
                <div style={{ flex: 1 }}>
                  <Descriptions column={2} size="small" bordered>
                    <Descriptions.Item label="Material Name" span={2}>
                      {previewRecord.material_name || '-'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Material Unique ID">
                      {previewRecord.material_unique_id || '-'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Lot No.">
                      {previewRecord.lot_number || '-'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Batch No.">
                      {previewRecord.batch_number || '-'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Quantity">
                      {previewRecord.quantity || '-'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Pack 1">
                      {previewRecord.pack_1 || '-'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Pack 2">
                      {previewRecord.pack_2 || '-'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Mfg Date">
                      {previewRecord.open_date || '-'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Expiry Date">
                      {previewRecord.expiry_date || '-'}
                    </Descriptions.Item>
                    {previewRecord.qr_type === 'C' && (
                      <>
                        <Descriptions.Item label="Gross Wt.">
                          {previewRecord.gross_weight || '-'}
                        </Descriptions.Item>
                        <Descriptions.Item label="Net Wt.">
                          {previewRecord.net_weight || '-'}
                        </Descriptions.Item>
                        <Descriptions.Item label="Tare Wt." span={2}>
                          {previewRecord.tare_weight || '-'}
                        </Descriptions.Item>
                      </>
                    )}
                  </Descriptions>
                </div>
              </div>
              <Divider style={{ margin: '12px 0' }} />
              <div style={{ fontSize: 12, color: '#888' }}>
                Created On: {previewRecord.created_on || '-'}
              </div>
            </div>
          )}
        </Modal>
        <Modal
          open={isVisible}
          title={'Modified Operation'}
          width={1200}
          onCancel={handleCancel}
          footer={null}
          zIndex="1500"
        >
          <div className="mt-4">
            <Table
              dataSource={modified_details}
              columns={processColumns}
              pagination={false}
              showHeader={true}
              expandable={{
                expandedRowRender: expandedRowRenderCols,
              }}
            />
          </div>
        </Modal>
        <Modal
          title="Terminate Batch"
          open={isModalVisible}
          onOk={onTerminate}
          onCancel={handleCommentCancel}
          okText="Submit"
          okButtonProps={{ disabled: !comment?.trim() }} // Disable if comment is empty
          cancelText="Cancel"
        >
          <label htmlFor="comment" style={{ display: 'block', marginBottom: '8px' }}>
            Comment
          </label>
          <Input.TextArea
            rows={4}
            placeholder="Enter your comment here..."
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />
        </Modal>
        <OperationsSkeleton
          show={showSummary}
          report={processOperations || []}
          setShow={set_showSummary}
          scheduletime={scheduleTimeStatus}
          selected_recipe={selected_recipe}
          tab={tab_value}
          setAssignStatus={setAssignStatus}
          assignStatus={assignStatus}
          selectedProcessId={selectedProcessId}
          current_batch={current_batch}
          set_selectedProcessId={set_selectedProcessId}
          selectedProcessName={selectedProcessName}
          set_showSummaryIndex={set_showSummaryIndex}
          bulk_assign_list={bulk_assign_list}
        />
        <BmrCheck
          setIsBmrVisible={setIsBmrVisible}
          isBmrVisible={isBmrVisible}
          batchId={batchId}
          start_batch={start_batch}
          batch_number={batch_numberNew}
          set_batch_numberNew={set_batch_numberNew}
          machine_id={machine_idNew}
        />
        <Modal
          title="Bill of Materials"
          open={isBomVisible}
          onCancel={handleCancel}
          footer={null}
          width={800}
          zIndex={2000}
        >
          <Table
            dataSource={bomList}
            loading={bomLoading}
            columns={[
              {
                title: 'Material Name',
                dataIndex: 'material_name',
                key: 'title',
                sorter: (a, b) => a?.material_name?.localeCompare(b?.material_name), // ✅ sorting
                filteredValue: [searchvalue],
                onFilter: (value, record) => {
                  return String(record.material_name).toLowerCase().includes(value.toLowerCase());
                },
                align: 'center',
              },
              {
                title: 'Quantity',
                dataIndex: 'quantity',
                key: 'quantity',
                align: 'center',
                sorter: (a, b) => a?.quantity - b?.quantity, // ✅ numeric sorting
                // Backend already returns quantity pre-calculated for the requested
                // batch_size (get_bill_of_materials) — show it as-is, just rounded to
                // 3 decimal places for display (e.g. 1147.4999999999998 -> 1147.5).
                render: (data, record) => `${Number(data).toFixed(3)} ${record?.unit || ''}`,
              },
              {
                title: 'Type',
                dataIndex: 'material_type',
                key: 'type',
                align: 'center',
              },
              {
                title: 'Lots',
                key: 'lots',
                align: 'center',
                render: (_, record) => {
                  const required = computeRequiredQty(record);
                  const chosen = selectedLots[record.material_id] || [];
                  const total = chosen.reduce((s, l) => s + (Number(l.consumed_qty) || 0), 0);
                  const fulfilled = total >= required && required > 0;
                  return (
                    <div>
                      <Button
                        size="small"
                        type={chosen.length ? 'default' : 'primary'}
                        onClick={() => openLotPicker(record)}
                      >
                        {chosen.length ? `${chosen.length} Lot(s)` : 'Select Lots'}
                      </Button>
                      {chosen.length > 0 && (
                        <div style={{ marginTop: 4, fontSize: 11 }}>
                          <Tag color={fulfilled ? 'green' : 'red'}>
                            {total} / {required} {record.unit || ''}
                          </Tag>
                        </div>
                      )}
                    </div>
                  );
                },
              },
            ]}
            pagination={{ pageSize: 5 }}
            bordered
          />
        </Modal>

        {/* ===== Lot Picker Modal ===== */}
        <Modal
          title={`Select Lots — ${lotPicker.material?.material_name || ''}`}
          open={lotPicker.open}
          onCancel={closeLotPicker}
          width={900}
          zIndex={2100}
          okText="Confirm"
          onOk={confirmLotPicker}
          okButtonProps={{ disabled: pickerTotal < lotPicker.required }}
          styles={{ body: { maxHeight: '70vh', overflowY: 'auto', paddingRight: 12 } }}
        >
          <div style={{ marginBottom: 12, display: 'flex', gap: 16, alignItems: 'center' }}>
            <Tag color="blue">
              Required: {lotPicker.required} {lotPicker.material?.unit || ''}
            </Tag>
            <Tag color={pickerTotal >= lotPicker.required ? 'green' : 'orange'}>
              Selected: {pickerTotal} {lotPicker.material?.unit || ''}
            </Tag>
            {pickerTotal < lotPicker.required && (
              <span style={{ color: '#c00', fontSize: 12 }}>
                Short by {lotPicker.required - pickerTotal} — add more lots
              </span>
            )}
          </div>
          <Table
            dataSource={availableLots}
            rowKey="lot_id"
            size="small"
            pagination={{ pageSize: 8 }}
            expandable={{
              expandedRowKeys: availableLots
                .filter((l) => pickerSelection[l.lot_id] !== undefined)
                .map((l) => l.lot_id),
              showExpandColumn: false,
              expandedRowRender: (lot) => {
                // Quality parameters now come per-lot from the API (read-only display).
                // Fall back to the material-level parameters list if the per-lot data is absent.
                const lotParams = Array.isArray(lot.quality_parameters)
                  ? lot.quality_parameters
                  : [];
                const params = lotParams.length
                  ? lotParams
                  : lotPicker.material?.quality_parameters || [];
                if (!params.length) {
                  return (
                    <div
                      style={{
                        padding: '4px 0',
                        fontSize: 12,
                        color: '#9ca3af',
                        fontStyle: 'italic',
                      }}
                    >
                      No quality parameters configured for this lot.
                    </div>
                  );
                }
                return (
                  <div
                    style={{
                      padding: '12px 16px',
                      background: '#eef2ff',
                      border: '1px solid #a5b4fc',
                      borderRadius: 6,
                    }}
                  >
                    <div
                      style={{
                        fontSize: 13,
                        fontWeight: 700,
                        color: '#3730a3',
                        marginBottom: 10,
                      }}
                    >
                      Quality Parameters — Lot {lot.lot_number}
                    </div>
                    <Table
                      dataSource={params}
                      rowKey={(r) => r.parameter_id ?? r.id ?? r.name}
                      size="small"
                      pagination={false}
                      bordered
                      columns={[
                        {
                          title: 'Parameter',
                          dataIndex: 'name',
                          key: 'name',
                          width: '40%',
                          render: (name) => (
                            <span style={{ fontWeight: 600, color: '#1f2937' }}>{name || '-'}</span>
                          ),
                        },
                        {
                          title: 'Unit',
                          dataIndex: 'unit',
                          key: 'unit',
                          width: '15%',
                          render: (u) => u || '-',
                        },
                        {
                          title: 'Data Type',
                          dataIndex: 'data_type',
                          key: 'data_type',
                          width: '15%',
                          render: (dt) => <Tag color="geekblue">{dt || 'String'}</Tag>,
                        },
                        {
                          title: 'Value',
                          key: 'value',
                          width: '30%',
                          render: (_, p) => {
                            const val = p.value;
                            if (val === undefined || val === null || val === '') {
                              return <span style={{ color: '#9ca3af' }}>—</span>;
                            }
                            if ((p.data_type || '').toLowerCase() === 'boolean') {
                              return (
                                <Tag color={val ? 'green' : 'default'}>{val ? 'Yes' : 'No'}</Tag>
                              );
                            }
                            return <span>{String(val)}</span>;
                          },
                        },
                      ]}
                    />
                  </div>
                );
              },
            }}
            columns={[
              {
                title: '',
                key: 'select',
                width: 50,
                render: (_, lot) => (
                  <AntCheckbox
                    checked={pickerSelection[lot.lot_id] !== undefined}
                    onChange={(e) => togglePickerLot(lot, e.target.checked)}
                  />
                ),
              },
              { title: 'Batch #', dataIndex: 'batch_number', key: 'batch_number' },
              { title: 'Lot #', dataIndex: 'lot_number', key: 'lot_number' },
              {
                title: 'Available',
                dataIndex: 'quantity_available',
                key: 'quantity_available',
                align: 'right',
                render: (v) => `${v} ${lotPicker.material?.unit || ''}`,
              },
              {
                title: 'Expiry',
                dataIndex: 'expiry_date',
                key: 'expiry_date',
                render: (d) => (d ? new Date(d).toLocaleDateString() : '-'),
              },
              {
                title: 'Consume Qty',
                key: 'consume',
                width: 140,
                render: (_, lot) => {
                  const checked = pickerSelection[lot.lot_id] !== undefined;
                  return (
                    <InputNumber
                      size="small"
                      min={0}
                      max={lot.quantity_available}
                      disabled={!checked}
                      value={pickerSelection[lot.lot_id]}
                      onChange={(val) => updatePickerLotQty(lot.lot_id, val)}
                      style={{ width: '100%' }}
                    />
                  );
                },
              },
            ]}
            locale={{ emptyText: 'No available lots for this material' }}
          />
        </Modal>
      </div>
      <Modal
        width={1200}
        title="Graph"
        open={showGraph}
        onCancel={() => setShowGraph(false)}
        footer={null}
        zIndex={1500}
      >
        <Graph batch_number={selectedBatchForGraph} />
      </Modal>
      <Modal
        width={1200}
        title="Release Lot"
        zIndex={1500}
        open={is_schedule_lot}
        onCancel={() => set_is_schedule_lot(false)}
        footer={null}
        destroyOnClose
      >
        {add_schedule('lot')}
        {/* {scheduleLotForm()} */}
      </Modal>
      <Base64Viewer
        batch_number={selectedBatchNumber}
        open={workflowReportView}
        onClose={() => setworkflowReportView(false)}
      />
      <DualESignatureAuth
        visible={showESignatureModal}
        onCancel={() => {
          setShowESignatureModal(false);
          setPendingApprovalBatch(null);
        }}
        onSubmit={(signatureData) => {
          handleApproveBatch(pendingApprovalBatch);
          setShowESignatureModal(false);
          setPendingApprovalBatch(null);
        }}
        signatureType="batch_release_approval"
        action_type="batch_release_approval"
        signatureMeaning="Batch Release Approval"
        documentType="BATCH"
        batch_number={pendingApprovalBatch?.batch_number || ''}
        documentId={pendingApprovalBatch?.batch_number || ''}
        documentNumber={pendingApprovalBatch?.batch_number || ''}
        documentData={{
          batch_number: pendingApprovalBatch?.batch_number || '',
          recipe_name: pendingApprovalBatch?.recipe_name || '',
          product_code: pendingApprovalBatch?.product_code || '',
          batch_size: pendingApprovalBatch?.batch_size || '',
          scheduled_time: pendingApprovalBatch?.scheduled_time || '',
        }}
        config={{
          enableBasic: true,
          enableCFR: true,
          defaultMode: 'cfr',
          requireComment: true,
          title: 'E-Signature for Batch Release Approval',
        }}
      />

      {/* MBMR Detail Modal */}
      <MBMRDetailsModal
        open={mbmrModal.open}
        recipeId={mbmrModal.recipeId}
        title={mbmrModal.title}
        onClose={() => setMbmrModal({ open: false, recipeId: null, title: '' })}
      />
    </>
  );
}

export default ScheduledBatches;
